import { generateCivilAviationLabelsAndValues, generateLabelsAndValues, generateLabelsAndValuesForAcademic, generateSchemaJpaGovernmentLabelsAndValues } from "../utils/helperFunctions";

export const TechnologyFieldsOptions = [
    {
        label: "Aerospace and Aviation Technology (AV)",
        value: 1,
        sub_fields: [
            {
                label: "Engineering & Design",
                value: 1,
            },
            {
                label: "Aerospace Manufacturing",
                value: 2,
            },
            {
                label: "Systems Integration",
                value: 3,
            },
            {
                label: "Maintenance, Repair & Overhaul",
                value: 4,
            },
            {
                label: "Continuing Airworthiness Management Organisation (CAMO)",
                value: 5,
            },
            {
                label: "Aerospace Support Services",
                value: 6,
            },
        ],
    },
    {
        label: "Agro-based Technology (AF)",
        value: 2,
        sub_fields: [
            {
                label: "Agriculture Ecosystem and Services",
                value: 1,
            },
            {
                label: "Crop Science",
                value: 2,
            },
            {
                label: "Animal Science",
                value: 3,
            },
        ],
    },
    {
        label: "Art Design & Creative Multimedia Technology (AM)",
        value: 3,
        sub_fields: [
            {
                label: "Creative Multimedia",
                value: 1,
            },
            {
                label: "Art & Design",
                value: 2,
            },
            {
                label: "Entertainment",
                value: 3,
            },
            {
                label: "Games Development",
                value: 4,
            },
        ],
    },
    {
        label: "Atmospheric Science & Environment Technology (AC)",
        value: 4,
        sub_fields: [
            {
                label: "Meteorology",
                value: 1,
            },
            {
                label: "Climate Change",
                value: 2,
            },
            {
                label: "Environmental Technologies",
                value: 3,
            },
            {
                label: "Ecology",
                value: 4,
            },
            {
                label: "Geophysics and Disaster",
                value: 5,
            },
            {
                label: "Hydrology",
                value: 6,
            },
        ],
    },
    {
        label: "Automotive Technology (AT)",
        value: 5,
        sub_fields: [
            {
                label: "Automotive Manufacturing",
                value: 1,
            },
            {
                label: "Powertrain",
                value: 2,
            },
            {
                label: "Technical/Technology Design",
                value: 3,
            },
            {
                label: "Mechanic Automotive",
                value: 4,
            },
        ],
    },
    {
        label: "Biotechnology (BT)",
        value: 6,
        sub_fields: [
            {
                label: "Agriculture Biotechnology",
                value: 1,
            },
            {
                label: "Industrial Biotechnology",
                value: 2,
            },
            {
                label: "Healthcare Biotechnology",
                value: 3,
            },
        ],
    },
    {
        label: "Building & Construction Technology (BC)",
        value: 7,
        sub_fields: [
            {
                label: "Infra Works",
                value: 1,
            },
            {
                label: "Building Works",
                value: 2,
            },
            {
                label: "Architecture",
                value: 3,
            },
            {
                label: "Property and Facilities Management",
                value: 4,
            },
            {
                label: "Contract Management",
                value: 5,
            },
            {
                label: "Road & Bridge",
                value: 6,
            },
        ],
    },
    {
        label: "Chemical Technology (CM)",
        value: 8,
        sub_fields: [
            {
                label: "Product",
                value: 1,
            },
            {
                label: "Process",
                value: 2,
            },
            {
                label: "Product Services",
                value: 3,
            },
            {
                label: "Commercial Technical Services",
                value: 4,
            },
        ],
    },
    {
        label: "Cyber Security Technology (CS)",
        value: 9,
        sub_fields: [
            {
                label: "Information Assurance",
                value: 1,
            },
            {
                label: "Network Security",
                value: 2,
            },
            {
                label: "Data Security",
                value: 3,
            },
            {
                label: "Societal and Organizational Security",
                value: 4,
            },
        ],
    },
    {
        label: "Electrical & Electronics Technology (EE)",
        value: 10,
        sub_fields: [
            {
                label: "Power - Generation, Transmissions & Distribution",
                value: 1,
            },
            {
                label: "Semiconductor",
                value: 2,
            },
            {
                label: "Control & Instrumentation",
                value: 3,
            },
            {
                label: "Signal Processing",
                value: 4,
            },
        ],
    },
    {
        label: "Food Technology (FT)",
        value: 11,
        sub_fields: [
            {
                label: "Food Processing",
                value: 1,
            },
            {
                label: "Food Science",
                value: 2,
            },
            {
                label: "Food Quality Assurance",
                value: 3,
            },
            {
                label: "Food Bioprocess",
                value: 4,
            },
        ],
    },
    {
        label: "Green Technology (GT)",
        value: 12,
        sub_fields: [
            {
                label: "Clean Energy",
                value: 1,
            },
            {
                label: "Green Building and Construction",
                value: 2,
            },
            {
                label: "Water and Waste Management",
                value: 3,
            },
            {
                label: "Clean Transportation",
                value: 4,
            },
            {
                label: "Sustainable Materials and Manufacturing",
                value: 5,
            },
            {
                label: "Eco Forestry and Agriculture",
                value: 6,
            },
        ],
    },
    {
        label: "Health & Medical Technology (HM)",
        value: 13,
        sub_fields: [
            {
                label: "Medical Equipment",
                value: 1,
            },
            {
                label: "Medical ICT",
                value: 2,
            },
            {
                label: "Healthcare Facilities",
                value: 3,
            },
        ],
    },
    {
        label: "Information & Communication Technology (IT)",
        value: 14,
        sub_fields: [
            {
                label: "ICT Strategic Management",
                value: 1,
            },
            {
                label: "Information & Data Strategy",
                value: 2,
            },
            {
                label: "Information Security Management",
                value: 3,
            },
            {
                label: "ICT Project Management",
                value: 4,
            },
            {
                label: "ICT Infrastructure Management",
                value: 5,
            },
            {
                label: "System Development",
                value: 6,
            },
            {
                label: "Software Testing & Quality Assurance",
                value: 7,
            },
        ],
    },
    {
        label: "Manufacturing & Industrial Technology (ME)",
        value: 15,
        sub_fields: [
            {
                label: "Industrial and Manufacturing Planning",
                value: 1,
            },
            {
                label: "Design, Development, Simulation and Optimization",
                value: 2,
            },
            {
                label: "Assembly, Disassembly and Packaging",
                value: 3,
            },
            {
                label: "Materials and Manufacturing Processes",
                value: 4,
            },
            {
                label: "Robotic, Automation and Artificial Intelligence",
                value: 5,
            },
            {
                label: "Testing, Commissioning, Metrology and Quality",
                value: 6,
            },
            {
                label: "Technical and Product Support",
                value: 7,
            },
            {
                label: "Operation, Performance, Reliability, and Improvement",
                value: 8,
            },
        ],
    },
    {
        label: "Marine Technology (MR)",
        value: 16,
        sub_fields: [
            {
                label: "Fisheries",
                value: 1,
            },
            {
                label: "Aquaculture",
                value: 2,
            },
            {
                label: "Conservation",
                value: 3,
            },
            {
                label: "Exploration",
                value: 4,
            },
            {
                label: "Pollution",
                value: 5,
            },
            {
                label: "Eco-System",
                value: 6,
            },
            {
                label: "Oceanography",
                value: 7,
            },
            {
                label: "Oceanology",
                value: 8,
            },
        ],
    },
    {
        label: "Maritime Technology (MI)",
        value: 17,
        sub_fields: [
            {
                label: "Seafaring",
                value: 1,
            },
            {
                label: "Navigation",
                value: 2,
            },
            {
                label: "Seamanship",
                value: 3,
            },
            {
                label: "Marine Engineering",
                value: 4,
            },
            {
                label: "Cargo",
                value: 5,
            },
            {
                label: "Ship",
                value: 6,
            },
            {
                label: "Boats",
                value: 7,
            },
            {
                label: "Oil Rigs",
                value: 8,
            },
            {
                label: "Ports",
                value: 9,
            },
            {
                label: "Submersible",
                value: 10,
            },
        ],
    },
    {
        label: "Material Science Technology (MT)",
        value: 18,
        sub_fields: [
            {
                label: "Metal",
                value: 1,
            },
            {
                label: "Ceramic",
                value: 2,
            },
            {
                label: "Polymer",
                value: 3,
            },
            {
                label: "Composite",
                value: 4,
            },
        ],
    },
    {
        label: "Nanotechnology (NT)",
        value: 19,
        sub_fields: [
            {
                label: "Semiconductor",
                value: 1,
            },
            {
                label: "Surface Science",
                value: 2,
            },
            {
                label: "Microfabrication",
                value: 3,
            },
            {
                label: "Molecular Technology",
                value: 4,
            },
            {
                label: "Nano Medicine",
                value: 5,
            },
            {
                label: "Nano Electronics",
                value: 6,
            },
            {
                label: "Energy",
                value: 7,
            },
        ],
    },
    {
        label: "Nuclear & Radiological Technology (NR)",
        value: 20,
        sub_fields: [
            {
                label: "Ionizing",
                value: 1,
            },
            {
                label: "Non-Ionizing",
                value: 2,
            },
        ],
    },
    {
        label: "Oil & Gas Technology (OG)",
        value: 21,
        sub_fields: [
            {
                label: "Exploration and Production",
                value: 1,
            },
            {
                label: "Chemical Process and Product",
                value: 2,
            },
            {
                label: "Logistics Oil and Gas",
                value: 3,
            },
            {
                label: "Energy and Utilities",
                value: 4,
            },
        ],
    },
    {
        label: "Resource Based, Survey and Geomatics Technology (RB)",
        value: 22,
        sub_fields: [
            {
                label: "Geographic Information System (GIS)",
                value: 1,
            },
            {
                label: "Remote Sensing",
                value: 2,
            },
            {
                label: "Land Survey",
                value: 3,
            },
            {
                label: "Mineral",
                value: 4,
            },
        ],
    },
    {
        label: "Telecommunication & Broadcasting Technology (TB)",
        value: 23,
        sub_fields: [
            {
                label: "Transmission",
                value: 1,
            },
            {
                label: "Radio Infra",
                value: 2,
            },
            {
                label: "Broadcasting",
                value: 3,
            },
            {
                label: "Studio Engineering",
                value: 4,
            },
        ],
    },
    {
        label: "Transportation & Logistic Technology (TL)",
        value: 24,
        sub_fields: [
            {
                label: "Railway",
                value: 1,
            },
            {
                label: "Shipping",
                value: 2,
            },
            {
                label: "Road",
                value: 3,
            },
            {
                label: "Cargo",
                value: 4,
            },
            {
                label: "Warehouse",
                value: 5,
            },
            {
                label: "Supply Process",
                value: 6,
            },
            {
                label: "Inventory Control",
                value: 7,
            },
            {
                label: "PSH&T (Packaging, Handling, Storage & Tracking)",
                value: 8,
            },
        ],
    },
];

export const RaceOptions = [
    {
        label: "Malay",
        value: 1,
    },
    {
        label: "Chinese",
        value: 2,
    },
    {
        label: "Indian",
        value: 3,
    },
    {
        label: "Other",
        value: 4,
    },
];

export const RACE_CONSTANTS = {
    MALAY: 1,
    CHINESE: 2,
    INDIAN: 3,
    OTHER: 4,
};

export const getRaceLabel = (raceCode) => {
    switch (raceCode) {
        case RACE_CONSTANTS.MALAY:
            return "Malay";
        case RACE_CONSTANTS.CHINESE:
            return "Chinese";
        case RACE_CONSTANTS.INDIAN:
            return "Indian";
        case RACE_CONSTANTS.OTHER:
            return "Other";
        default:
            return "Unknown";
    }
};

export const TitleOptions = [
    {
        label: "Ms",
        value: 1,
    },
    {
        label: "Mrs",
        value: 2,
    },
    {
        label: "Mr",
        value: 3,
    },
];

export const GENDER_OPTIONS = {
    MALE: 1,
    FEMALE: 2,
};

export const GENDER_CONSTANTS = {
    MALE: "male",
    FEMALE: "female",
};

export const PreferredRegistration = {
    GRADUATE_TECHNOLOGIST: 1,
    QUALIFIED_TECHNICIAN: 2,
    PROFESSIONAL_TECHNOLOGIST: 3,
    CERTIFIED_TECHNICIAN: 4,
};

export const CertificateTypeStrings = {
    [PreferredRegistration.GRADUATE_TECHNOLOGIST]: "Graduate Technologist",
    [PreferredRegistration.QUALIFIED_TECHNICIAN]: "Qualified Technician",
    [PreferredRegistration.PROFESSIONAL_TECHNOLOGIST]: "Professional Technologist",
    [PreferredRegistration.CERTIFIED_TECHNICIAN]: "Certified Technician",
};

export const PreferredRegistrationLabelsAndValues = generateLabelsAndValues(PreferredRegistration);

export const getPreferredRegistrationLabel = (reg) => {
    switch (reg) {
        case PreferredRegistration.GRADUATE_TECHNOLOGIST:
            return "Graduate Technologist";
        case PreferredRegistration.QUALIFIED_TECHNICIAN:
            return "Qualified Technician";
        default:
            return "Unknown";
    }
};

export const TYPE_OF_QUALIFICATION_CONSTANTS = {
    DOCTORAL_DEGREE: 1,
    MASTER_DEGREE: 2,
    BACHELOR_DEGREE: 3,
    ADVANCED_DIPLOMA: 4,
    DIPLOMA: 5,
    CERTIFICATE_LEVEL_3: 6,
    CERTIFICATE_OF_COMPETENCY: 7,
};

export const getTypeNameByType = (type) => {
    const qualification = QualificationLabelsAndValues.find((q) => q.value === type);
    return qualification.label;
};

export const FIELD_OF_STUDY_CONSTANTS = {
    TECHNOLOGY_AND_TECHNICAL: 2,
    ENGINEERING: 1, // Merged Engineering & Engineering Technology
    SCIENCE_APPLIED_SCIENCE: 3,
    NON_TECHNICAL: 4,
};

export const QualificationLabelsAndValues = generateLabelsAndValues(TYPE_OF_QUALIFICATION_CONSTANTS);

export const ProgrammeLabelsAndValues = generateLabelsAndValuesForAcademic(FIELD_OF_STUDY_CONSTANTS);

export const CURRENT_WORKING_SECTOR_CONSTANTS = {
    GOVERNMENT: 1,
    PRIVATE: 2,
};

export const getWorkingSectorLabel = (sector) => {
    switch (sector) {
        case CURRENT_WORKING_SECTOR_CONSTANTS.GOVERNMENT:
            return "Government";
        case CURRENT_WORKING_SECTOR_CONSTANTS.PRIVATE:
            return "Private";
        default:
            return "Unknown";
    }
};

export const CurrentWorkingLabelsAndValues = generateLabelsAndValues(CURRENT_WORKING_SECTOR_CONSTANTS);

export const SCHEMA_JPA_GOVERNMENT = {
    PENGANGKUTAN: 1,
    BAKAT_DAN_SENI: 2,
    SAINS: 3,
    PENDIDIKAN: 4,
    EKONOMI: 5,
    SISTEM_MAKLUMAT: 6,
    PERTANIAN: 7,
    KEMAHIRAN: 8,
    KEJURUTERAAN: 9,
    KESELAMATAN: 10,
    PERUNDANGAN_DAN_KEHAKIMAN: 11,
    TADBIR_DAN_DIPLOMATIK: 12,
    PENTADBIRAN_DAN_SOKONGAN: 13,
    PERNCEGAHAN: 14,
    PENTADBIRAN_DAN_PEMBANGUNAN: 15,
    SOSIAL: 16,
    PENGUAKUASAAN_MARITIM: 17,
    PERUBATAN_DAN_KESIHATAN: 18,
    KEWANGAN: 19,
    POLIS: 20,
    TENTERA: 21,
};

export const SCHEMA_JPA_PRIVATE = {
    INDUSTRY: 22,
    IPTS_ILKS: 23,
    OTHERS: 24,
};

export const SCHEMA_JPA_PRIVATE_OPTIONS = [
    { label: "Industry", value: SCHEMA_JPA_PRIVATE.INDUSTRY },
    { label: "IPTS/ ILKS", value: SCHEMA_JPA_PRIVATE.IPTS_ILKS },
    { label: "Others", value: SCHEMA_JPA_PRIVATE.OTHERS },
];

export const SchemeJpaGovLabelsAndValues = generateSchemaJpaGovernmentLabelsAndValues(SCHEMA_JPA_GOVERNMENT);

export const SchemeJpaPvtLabelsAndValues = generateLabelsAndValues(SCHEMA_JPA_PRIVATE);

export const WORKING_SECTOR = {
    GOVERNMENT: "government",
    PRIVATE: "private",
};

export const step3FormInitialValues = {
    type: "",
    program_name: "",
    program_other: "",
    university: "",
    university_other: "",
    from: "",
    to: "",
    field_of_study: "",
    field_of_study_other: "",
    file: "",
};

export const step4FormInitialValues = {
    current_working_sector: "",
    scheme_jpa: "",
    scheme_jpa_other: "",
    technology_field: "",
    technology_sub_field: "",
    company_name: "",
    designation: "",
    company_address: "",
    from: "",
    to: "",
    file: "",
    is_present: "",
};

export const findTechnologyField = (value) => {
    const data = TechnologyFieldsOptions.find((ele) => ele.value === value);
    return data?.label;
};

export const TYPE_OF_PROGRAMEE_GT = {
    CIVIL_AVIATION_AUTHORITY_OF_MALAYSIA: "Civil Aviation Authority of Malaysia (CAAM)",
    JABATAN_LAUT_DIRAJA_MALAYSIA: "Jabatan Laut Diraja Malaysia (JLM)",
};
export const TYPE_OF_PROGRAMEE_QT = {
    ENERGY_COMMISSION: "Energy Commission (Suruhanjaya Tenaga)",
    CIVIL_AVIATION_AUTHORITY_OF_MALAYSIA: "Civil Aviation Authority of Malaysia (CAAM)",
    JABATAN_LAUT_DIRAJA_MALAYSIA: "Jabatan Laut Diraja Malaysia (JLM)",
    TENTERA_LAUT_DIRAJA_MALAYSIA: "Tentera Laut Diraja Malaysia (TLDM)",
    ELECTRICAL_INSPECTORATE_UNIT: "Electrical Inspectorate Unit (EIU)",
};
export const TYPE_OF_PROGRAMEE = {
    ENERGY_COMMISSION: "Energy Commission (Suruhanjaya Tenaga)",
    CIVIL_AVIATION_AUTHORITY_OF_MALAYSIA: "Civil Aviation Authority of Malaysia (CAAM)",
    JABATAN_LAUT_DIRAJA_MALAYSIA: "Jabatan Laut Diraja Malaysia (JLM)",
    TENTERA_LAUT_DIRAJA_MALAYSIA: "Tentera Laut Diraja Malaysia (TLDM)",
    ELECTRICAL_INSPECTORATE_UNIT: "Electrical Inspectorate Unit (EIU)",
};
export const GTProgrameeNameLabelAndValues = generateCivilAviationLabelsAndValues(TYPE_OF_PROGRAMEE_GT);
export const QTProgrameeNameLabelAndValues = generateCivilAviationLabelsAndValues(TYPE_OF_PROGRAMEE_QT);
export const ProgrameeNameLabelAndValues = generateCivilAviationLabelsAndValues(TYPE_OF_PROGRAMEE);

export const TYPE_OF_ENERGY_COMMISSION = {
    PENDAWAI_ELEKTRIK_3_FASA_PW3: "Wireman three phase (PW3)",
    PENDAWAI_ELEKTRIK_4_FASA_PW4: "Wireman three phase (PW4)",
    PENJAGA_JENTERA_ELEKTRIK_VOLTAN_RENDAH_A0: "Chargeman low voltage (A0)",
    PENJAGA_JENTERA_ELEKTRIK_VOLTAN_RENDAH_A1: "Chargeman low voltage (A1)",
    PENJAGA_JENTERA_ELEKTRIK_VOLTAN_RENDAH_A4: "Chargeman low voltage (A4)",
    PENJAGA_JENTERA_ELEKTRIK_VOLTAN_TINGGI_B0: "Chargeman high voltage (B0)",
    PENJAGA_JENTERA_ELEKTRIK_VOLTAN_TINGGI_B1: "Chargeman high voltage (B1)",
    PENJAGA_JENTERA_ELEKTRIK_VOLTAN_TINGGI_B4: "Chargeman high voltage (B4)",
};
export const EnergyCommissionLagelsAndValues = generateCivilAviationLabelsAndValues(TYPE_OF_ENERGY_COMMISSION);
export const TYPE_OF_CIVIL_AVIATION_GT = {
    PART_66_CATEGORY_C: "Part 66 Category C – Aircraft Maintenance Engineer (including at least one type rating)",
    PART_66_CATEGORY_B1_B2: "Part 66 Category B1/B2 – Aircraft Maintenance Engineer (including at least one type rating)",
};
export const CivilAviationGTLabelsAndValues = generateCivilAviationLabelsAndValues(TYPE_OF_CIVIL_AVIATION_GT);
export const TYPE_OF_CIVIL_AVIATION_QT = {
    CATEGORY_B1_B2_WITHOUT_TYPE: "Part 66 Category B1/B2 – Aircraft Maintenance Engineer (without any type rating)",
    CATEGORY_A1: "Part 66 Category A - Line Maintenance Technician (A1 - Aeroplanes Turbine)",
    CATEGORY_A2: "Part 66 Category A - Line Maintenance Technician (A2 - Aeroplanes Piston)",
    CATEGORY_A3: "Part 66 Category A - Line Maintenance Technician (A3 - Helicopters Turbine)",
    CATEGORY_A4: "Part 66 Category A - Line Maintenance Technician (A4 - Helicopters Piston)",
};
export const CivilAviationQTLabelsAndValues = generateCivilAviationLabelsAndValues(TYPE_OF_CIVIL_AVIATION_QT);
export const TYPE_OF_JABATAN_LAUT_GT = {
    CHIEF_ENGINEER_OFFICER: "Chief Engineer Officer of 3000 KW or more unlimited",
    SECOND_ENGINEER_OFFICER: "Second Engineer Officer of 3000 KW or more unlimited",
};
export const JabatanLautGTLabelsAndValues = generateCivilAviationLabelsAndValues(TYPE_OF_JABATAN_LAUT_GT);
export const TYPE_OF_JABATAN_LAUT_QT = {
    WATCHKEEPING_ENGINEER: "Watchkeeping Engineer 750kw or more",
};
export const JabatanLautQTLabelsAndValues = generateCivilAviationLabelsAndValues(TYPE_OF_JABATAN_LAUT_QT);
export const TYPE_OF_TENTERA_LAUT = {
    TEKNISYEN_MARIN_KUASA_GERAK: "Teknisyen Marin Kuasa Gerak (TMK)",
    TEKNISYEN_MARIN_SRIMALA: "Teknisyen Marin Srimala (TMS)",
    TEKNISYEN_LETRIK_SENJATA: "Teknisyen Letrik Senjata (TLS)",
    TEKNISYEN_LETRIK_RADIO: "Teknisyen Letrik Radio (TLR)",
};
export const TenteraLautLabelsAndValues = generateCivilAviationLabelsAndValues(TYPE_OF_TENTERA_LAUT);
export const TYPE_OF_ELECTRICAL_INSPECTORATE = {
    WIREMAN_GRADE_1: "Wireman Grade 1 (three phase wiring)",
    CHARGEMAN_L1: "Chargeman L1 (Main switch board and auxiliaries)",
    CHARGEMAN_L2: "Chargeman L2 (Overhead lines and auxiliaries / Underground cable laying and auxiliaries)",
    CHARGEMAN_L3: "Chargeman L3 (Generating stations)",
};
export const ElectricalInspectorLabelsAndValues = generateCivilAviationLabelsAndValues(TYPE_OF_ELECTRICAL_INSPECTORATE);
export const COMBINED_CONSTANTS = {
    ...TYPE_OF_ENERGY_COMMISSION,
    ...TYPE_OF_CIVIL_AVIATION_GT,
    ...TYPE_OF_CIVIL_AVIATION_QT,
    ...TYPE_OF_JABATAN_LAUT_GT,
    ...TYPE_OF_JABATAN_LAUT_QT,
    ...TYPE_OF_TENTERA_LAUT,
    ...TYPE_OF_ELECTRICAL_INSPECTORATE,
};

export const CombinedLabelsAndValues = generateCivilAviationLabelsAndValues(COMBINED_CONSTANTS);

export const UNIVERSITY_CONSTANTS = {
    OTHERS: "Others",
};

export const MULTIPLE_INSTITUTION = {
    IIUM_WILAYAH: "International Islamic University Malaysia (IIUM) Wilayah Persekutuan Kuala Lumpur",
    IIUM_PAHANG: "International Islamic University Malaysia (IIUM) Pahang",
    SULTAN_IDRIS_EDUCATION_UNIVERSITY: "Sultan Idris Education University",
    UKM_SELANGOR: "Universiti Kebangsaan Malaysia (UKM) Selangor",
    UKM_WILAYAH: "Universiti Kebangsaan Malaysia (UKM) Wilayah Persekutuan Kuala Lumpur",
    UKM: "Universiti Kebangsaan Malaysia (UKM)",
    UKM_KOTA_BHARU: "Universiti Malaysia Kelantan (UMK) Kota Bharu",
    UKM_BACHOK: "Universiti Malaysia Kelantan (UMK) Bachok",
    UMP_KUKTEM: "Universiti Malaysia Pahang (UMP)(Previously known as : Kolej Universiti Kejuruteraan & Teknologi Malaysia (KUKTEM))",
    UNIMAP_KUKUM: "Universiti Malaysia Perlis (UniMAP)(Previously known as : Kolej Universiti Kejuruteraan Utara Malaysia (KUKUM))",
    UMS: "Universiti Malaysia Sabah (UMS)",
    UNIVERSITI_MALAYSIA_SARAWAK: "Universiti Malaysia Sarawak",
    UNIMAS_KUCHING: "Universiti Malaysia Sarawak (UNIMAS) (Kuching)",
    UMT_KUSTEM: "Universiti Malaysia Terengganu (UMT)(Previously known as : Kolej Universiti Sains & Teknologi Malaysia (KUSTEM))",
    UNIVERSITI_PERTAHANAN_NASIONAL_MALAYSIA: "Universiti Pertahanan Nasional Malaysia",
    UPM_SELANGOR: "Universiti Putra Malaysia (UPM) Selangor",
    UPM_SARAWAK: "Universiti Putra Malaysia (UPM) Sarawak",
    USIM_KUIM: "Universiti Sains Islam Malaysia (USIM)(Previously known as : Kolej Universiti Islam Malaysia (KUIM))",
    USM: "Universiti Sains Malaysia (USM)",
    USM_KAMPUS_KESIHATAN: "Universiti Sains Malaysia (USM) (Kampus Kesihatan)",
    USM_NIBONGTEBAL: "Universiti Sains Malaysia (USM) (NibongTebal)",
    UNISZA_UDM: "Universiti Sultan Zainal Abidin (UniSZA)(Previously known as : Universiti Darul Iman Malaysia (UDM))",
    UNISZA_KAMPUS_GONG_BADAK: "Universiti Sultan Zainal Abidin (UniSZA) (Kampus Gong Badak)",
    UNISZA_KAMPUS_TEMBILA: "Universiti Sultan Zainal Abidin (UniSZA) (Kampus Tembila)",
    UTEM_KUTKM: "Universiti Teknikal Malaysia Melaka (UTeM)(Previously known as : Kolej Universiti Teknikal Kebangsaan Malaysia (KUTKM))",
    UTM: "Universiti Teknologi Malaysia (UTM)",
    UITM_CAWANGAN: "Universiti Teknologi MARA (UiTM) Cawangan Pulau Pinang Kampus Balik Pulau",
    UITM_SHAH_ALAM: "Universiti Teknologi MARA (UiTM) Shah Alam",
    UITM_PULAU_PINANG_BERTAM: "Universiti Teknologi MARA Cawangan Pulau Pinang Kampus Bertam",
    UITM_PULAU_PINANG_BUKIT_MERTAJAM: "Universiti Teknologi MARA Cawangan Pulau Pinang Kampus Bukit Mertajam",
    UITM_PULAU_PINANG_PERMATANG_PAUH: "Universiti Teknologi MARA Cawangan Pulau Pinang Kampus Permatang Pauh",
    UITM_SABAH_KOTA_KINABALU: "Universiti Teknologi MARA Cawangan Sabah Kampus Kota Kinabalu",
    UITM_SABAH_TAWAU: "Universiti Teknologi MARA Cawangan Sabah Kampus Tawau",
    UITM_SARAWAK_MUKAH: "Universiti Teknologi MARA Cawangan Sarawak Kampus Mukah",
    UITM_SARAWAK_MUKAH_2: "Universiti Teknologi MARA Cawangan Sarawak Kampus Mukah 2",
    UITM_SARAWAK_SAMARAHAN: "Universiti Teknologi MARA Cawangan Sarawak Kampus Samarahan",
    UITM_SARAWAK_SAMARAHAN_2: "Universiti Teknologi MARA Cawangan Sarawak Kampus Samarahan 2",
    UITM_SELANGOR_DENGKIL: "Universiti Teknologi MARA Cawangan Selangor Kampus Dengkil",
    UITM_SELANGOR_PUNCAK_ALAM: "Universiti Teknologi MARA Cawangan Selangor Kampus Puncak Alam",
    UITM_SELANGOR_PUNCAK_PERDANA: "Universiti Teknologi MARA Cawangan Selangor Kampus Puncak Perdana",
    UITM_SELANGOR_SEKSYEN_17: "Universiti Teknologi MARA Cawangan Selangor Kampus Seksyen 17",
    UITM_SELANGOR_SUNGAI_BULOH: "Universiti Teknologi MARA Cawangan Selangor Kampus Sungai Buloh",
    UITM_TERENGGANU_BUKIT_BESI: "Universiti Teknologi MARA Cawangan Terengganu Kampus Bukit Besi",
    UITM_TERENGGANU_DUNGUN: "Universiti Teknologi MARA Cawangan Terengganu Kampus Dungun",
    UITM_TERENGGANU_KUALA_TERENGGANU: "Universiti Teknologi MARA Cawangan Terengganu Kampus Kuala Terengganu",
    UITM_TERENGGANU_KUALA_TERENGGANU_CENDERING: "Universiti Teknologi MARA Cawangan Terengganu Kampus Kuala Terengganu (Cendering)",
    UTHM_PANCHOR: "Universiti Tun Hussein Onn Malaysia (UTHM) Panchor",
    UTHM_BATU_PAHAT: "Universiti Tun Hussein Onn Malaysia (UTHM) Batu Pahat (Previously known as : Kolej Universiti Teknologi Tun Hussein Onn (KUITTHO))",
    UITM_JOHOR_JOHOR_BAHARU: "Universiti Teknologi MARA Cawangan Johor Kampus Johor Bahru",
    UITM_JOHOR_LARKIN: "Universiti Teknologi MARA Cawangan Johor Kampus Larkin",
    UITM_JOHOR_PASIR_GUDANG: "Universiti Teknologi MARA Cawangan Johor Kampus Pasir Gudang",
    UITM_JOHOR_SEGAMAT: "Universiti Teknologi MARA Cawangan Johor Kampus Segamat",
    UITM_KEDAH_ALOR_SETAR: "Universiti Teknologi MARA Cawangan Kedah Kampus Alor Setar",
    UITM_KEDAH_SUNGAI_PETANI: "Universiti Teknologi MARA Cawangan Kedah Kampus Sungai Petani",
    UITM_KELANTAN_KOTA_BHARU: "Universiti Teknologi MARA Cawangan Kelantan Kampus Kota Bharu",
    UITM_KELANTAN_MACHANG: "Universiti Teknologi MARA Cawangan Kelantan Kampus Machang",
    UITM_MELAKA_ALOR_GAJAH: "Universiti Teknologi MARA Cawangan Melaka Kampus Alor Gajah",
    UITM_MELAKA_BANDARAYA: "Universiti Teknologi MARA Cawangan Melaka Kampus Bandaraya Melaka",
    UITM_MELAKA_JASIN: "Universiti Teknologi MARA Cawangan Melaka Kampus Jasin",
    UITM_NSEMBILAN_KUALA_PILAH: "Universiti Teknologi MARA Cawangan Negeri Sembilan Kampus Kuala Pilah",
    UITM_NSEMBILAN_KUALA_PILAH_BETING: "Universiti Teknologi MARA Cawangan Negeri Sembilan Kampus Kuala Pilah (Beting)",
    UITM_NSEMBILAN_REMBAU: "Universiti Teknologi MARA Cawangan Negeri Sembilan Kampus Rembau",
    UITM_NSEMBILAN_SEREMBAN: "Universiti Teknologi MARA Cawangan Negeri Sembilan Kampus Seremban",
    UITM_PAHANG_BUKIT_SEKILAU: "Universiti Teknologi MARA Cawangan Pahang Kampus Bukit Sekilau",
    UITM_PAHANG_JENGKA: "Universiti Teknologi MARA Cawangan Pahang Kampus Jengka",
    UITM_PAHANG_KUANTAN: "Universiti Teknologi MARA Cawangan Pahang Kampus Kuantan",
    UITM_PAHANG_RAUB: "Universiti Teknologi MARA Cawangan Pahang Kampus Raub",
    UITM_PERAK_SERI_ISKANDAR: "Universiti Teknologi MARA Cawangan Perak Kampus Seri Iskandar",
    UITM_PERAK_TAPAH: "Universiti Teknologi MARA Cawangan Perak Kampus Tapah",
    UITM_PERLIS_ARAU: "Universiti Teknologi MARA Cawangan Perlis Kampus Arau",
    UUM_KUALA_LUMPUR: "Universiti Utara Malaysia - Campus (Kuala Lumpur Branch)",
    UUM: "Universiti Utara Malaysia (UUM)",
    UNIVERSITY_OF_MALAYA: "University of Malaya",
    POLITEKNIK_BAGAN_DATUK: "Politeknik Bagan Datuk",
    POLITEKNIK_BALIK_PULAU: "Politeknik Balik Pulau",
    POLITEKNIK_BANTING_SELANGOR: "Politeknik Banting Selangor",
    POLITEKNIK_BESUT_TERENGGANU: "Politeknik Besut Terengganu",
    POLITEKNIK_HULU_TERENGGANU: "Politeknik Hulu Terengganu",
    POLITEKNIK_IBRAHIM_SULTAN: "Politeknik Ibrahim Sultan",
    POLITEKNIK_JELI_KELANTAN: "Politeknik Jeli Kelantan",
    POLITEKNIK_KOTA_BHARU: "Politeknik Kota Bharu",
    POLITEKNIK_KOTA_KINABALU: "Politeknik Kota Kinabalu",
    POLITEKNIK_KUALA_TERENGGANU: "Politeknik Kuala Terengganu",
    POLITEKNIK_KUCHING_SARAWAK: "Politeknik Kuching Sarawak",
    POLITEKNIK_MELAKA: "Politeknik Melaka",
    POLITEKNIK_MERLIMAU_MELAKA: "Politeknik Merlimau Melaka",
    POLITEKNIK_MERSING_JOHOR: "Politeknik Mersing Johor",
    POLITEKNIK_METRO_BETONG_SARAWAK: "METrO Betong Sarawak Polytechnic",
    POLITEKNIK_METRO_JOHOR_BAHARU: "Politeknik METrO Johor Bahru",
    POLITEKNIK_METRO_KUALA_LUMPUR: "METrO Kuala Lumpur Polytechnic",
    POLITEKNIK_METRO_KUANTAN: "Politeknik METrO Kuantan",
    POLITEKNIK_METRO_TASEK_GELUGOR: "Politeknik METrO Tasek Gelugor",
    POLITEKNIK_MUADZAM_SHAH: "Politeknik Muadzam Shah",
    POLITEKNIK_MUKAH_SARAWAK: "Politeknik Mukah (Sarawak)",
    POLITEKNIK_NILAI: "Politeknik Nilai",
    POLITEKNIK_PORT_DICKSON: "Politeknik Port Dickson",
    POLITEKNIK_SANDAKAN_SABAH: "Politeknik Sandakan Sabah",
    POLITEKNIK_SEBERANG_PERAI: "Seberang Perai Polytechnic",
    POLITEKNIK_SULTAN_ABDUL_HALIM_MUADZAM_SHAH: "Politeknik Sultan Abdul Halim Mu'adzam Shah",
    POLITEKNIK_SULTAN_AZLAN_SHAH: "Politeknik Sultan Azlan Shah",
    POLITEKNIK_SULTAN_HAJI_AHMAD_SHAH: "Politeknik Sultan Haji Ahmad Shah",
    POLITEKNIK_SULTAN_IDRIS_SHAH: "Politeknik Sultan Idris Shah",
    POLITEKNIK_SULTAN_MIZAN_ZAINAL_ABIDIN: "Politeknik Sultan Mizan Zainal Abidin",
    POLITEKNIK_SULTAN_SALAHUDDIN_ABDUL_AZIZ_SHAH: "Politeknik Sultan Salahuddin Abdul Aziz Shah",
    POLITEKNIK_TAWAU_SABAH: "Politeknik Tawau Sabah",
    POLITEKNIK_TUANKU_SULTANAH_BAHIYAH: "Politeknik Tuanku Sultanah Bahiyah",
    POLITEKNIK_TUANKU_SYED_SIRAJUDDIN: "Politeknik Tuanku Syed Sirajuddin",
    POLITEKNIK_TUN_SYED_NASIR_SYED_ISMAIL: "Tun Syed Nasir Syed Ismail Polytechnic",
    POLITEKNIK_UNGKU_OMAR: "Politeknik Ungku Omar",
    ACADEMY_FAMILY_PHYSICIANS_MALAYSIA: "The Academy of Family Physicians of Malaysia",
    AKADEMI_PERIKANAN_MALAYSIA: "Akademi Perikanan Malaysia (APM)",
    NATIONAL_ACADEMY_ARTS_CULTURE_HERITAGE: "National Academy of Arts Culture and Heritage",
    DARUL_QURAN_JAKIM: "Darul Quran, Jabatan Kemajuan Islam Malaysia (JAKIM)",
    INSTITUT_KEMAHIRAN_BELIA_NEGARA_TEMERLOH: "Institut Kemahiran Belia Negara Temerloh",
    INSTITUT_KEMAHIRAN_ISLAM_MALAYSIA_SARAWAK: "Institut Kemahiran Islam Malaysia Sarawak (IKMAS)",
    INSTITUT_KEMAHIRAN_MARA_ALOR_SETAR: "Institut Kemahiran MARA Alor Setar",
    INSTITUT_KEMAHIRAN_MARA_BESERI: "Institut Kemahiran MARA Beseri",
    INSTITUT_KEMAHIRAN_MARA_BESUT: "Institut Kemahiran MARA Besut",
    INSTITUT_KEMAHIRAN_MARA_BINTULU: "Institut Kemahiran MARA Bintulu",
    INSTITUT_KEMAHIRAN_MARA_JASIN: "Institut Kemahiran MARA Jasin",
    INSTITUT_KEMAHIRAN_MARA_JOHOR_BAHARU: "Institut Kemahiran MARA Johor Bahru",
    INSTITUT_KEMAHIRAN_MARA_KOTA_KINABALU: "Institut Kemahiran MARA Kota Kinabalu",
    INSTITUT_KEMAHIRAN_MARA_KUALA_LUMPUR: "Institut Kemahiran MARA Kuala Lumpur",
    INSTITUT_KEMAHIRAN_MARA_KUCHING: "Institut Kemahiran MARA Kuching",
    INSTITUT_KEMAHIRAN_MARA_LUMUT: "Institut Kemahiran MARA Lumut",
    INSTITUT_KEMAHIRAN_MARA_SEBERANG_PERAI_UTARA: "Institut Kemahiran MARA Seberang Perai Utara",
    INSTITUT_KEMAHIRAN_MARA_SIK: "Institut Kemahiran MARA Sik",
    INSTITUT_KEMAHIRAN_MARA_SUNGAI_PETANI: "Institut Kemahiran MARA Sungai Petani",
    INSTITUT_KEMAHIRAN_MARA_TAN_SRI_YAHAYA_AHMAD: "Institut Kemahiran MARA Tan Sri Yahaya Ahmad, Pekan",
    PERDA_ADVANCED_TECHNICAL_INSTITUTE: "PERDA Advanced Technical Institute",
    NATIONAL_CRAFT_INSTITUTE: "National Craft Institute",
    ILKKM_KEJURURAWATAN_ALOR_SETAR: "Institut Latihan Kementerian Kesihatan Malaysia (Kejururawatan) Alor Setar, Kedah (Previously known as : Kolej Kejururawatan Alor Setar)",
    ILKKM_KEJURURAWATAN_GEORGETOWN: "Institut Latihan Kementerian Kesihatan Malaysia (Kejururawatan) Georgetown, Pulau Pinang (Previously known as : Kolej Kejururawatan Pulau Pinang)",
    ILKKM_KEJURURAWATAN_KUALA_TERENGGANU: "Institut Latihan Kementerian Kesihatan Malaysia (Kejururawatan) Kuala Terengganu, Terengganu (Previously known as : Kolej Kejururawatan Kuala Terengganu)",
    ILKKM_KEJURURAWATAN_KUANTAN: "Institut Latihan Kementerian Kesihatan Malaysia (Kejururawatan) Kuantan, Pahang (Previously known as : Kolej Kejururawatan Kuantan)",
    ILKKM_KEJURURAWATAN_KUBANG_KERIAN: "Institut Latihan Kementerian Kesihatan Malaysia (Kejururawatan) Kubang Kerian, Kelantan (Previously known as : Kolej Kejururawatan Kubang Kerian)",
    ILKKM_KEJURURAWATAN_MELAKA: "Institut Latihan Kementerian Kesihatan Malaysia (Kejururawatan) Melaka (Previously known as : Kolej Kejururawatan Melaka)",
    ILKKM_PEMBANTU_PERUBATAN_ALOR_SETAR: "Institut Latihan Kementerian Kesihatan Malaysia (Pembantu Perubatan) Alor Setar, Kedah",
    ILKKM_PEMBANTU_PERUBATAN_SEREMBAN: "Institut Latihan Kementerian Kesihatan Malaysia (Pembantu Perubatan) Seremban, Negeri Sembilan",
    ILKKM_TEKNOLOGI_MAKMAL_PERUBATAN_KL: "Institut Latihan Kementerian Kesihatan Malaysia (Teknologi Makmal Perubatan) Kuala Lumpur",
    ILKKM_JOHOR_BAHARU: "Institut Latihan Kementerian Kesihatan Malaysia Johor Bahru, Johor (Previously known as : Kolej Sains Kesihatan Bersekutu Johor Bahru)",
    ILKKM_KOTA_KINABALU: "Institut Latihan Kementerian Kesihatan Malaysia Kota Kinabalu, Sabah (Previously known as : Kolej Sains Kesihatan Bersekutu Kota Kinabalu)",
    ILKKM_KUCHING: "Institut Latihan Kementerian Kesihatan Malaysia Kuching, Sarawak (Previously known as : Kolej Sains Kesihatan Bersekutu Kuching)",
    ILKKM_SULTAN_AZLAN_SHAH_IPOH: "Institut Latihan Kementerian Kesihatan Malaysia Sultan Azlan Shah Ipoh, Perak (Previously known as : Kolej Sains Kesihatan Bersekutu Sultan Azlan Shah)",
    ILKKM_SUNGAI_BULOH: "Institut Latihan Kementerian Kesihatan Malaysia Sungai Buloh, Selangor (Previously known as : Kolej Sains Kesihatan Bersekutu Sungai Buloh)",
    ARMED_FORCES_HEALTH_TRAINING_INSTITUTE: "Armed Forces Health Training Institute",
    INDUSTRIAL_TRAINING_INSTITUTE_KOTA_BHARU: "Industrial Training Institute Kota Bharu (ITI Kota Bharu)",
    ILP_KUALA_TERENGGANU: "Institut Latihan Perindustrian Kuala Terengganu (ILP Kuala Terengganu)",
    IPG_KAMPUS_BAHASA_MELAYU: "Institut Pendidikan Guru (IPG) (Kampus Bahasa Melayu)",
    IPG_KAMPUS_DARULAMAN: "Institut Pendidikan Guru (IPG) (Kampus Darulaman)",
    IPG_KAMPUS_DATO_RAZALI_ISMAIL: "Institut Pendidikan Guru (IPG) (Kampus Dato' Razali Ismail)",
    IPG_KAMPUS_IPOH: "Institut Pendidikan Guru (IPG) (Kampus Ipoh)",
    IPG_KENT_CAMPUS: "Institute of Teacher Education Kent Campus",
    IPG_KAMPUS_PERLIS: "Institut Pendidikan Guru (IPG) (Kampus Perlis)",
    IPG_KAMPUS_PULAU_PINANG: "Institut Pendidikan Guru (IPG) (Kampus Pulau Pinang)",
    IPG_RAJANG_CAMPUS: "Institute of Teacher Education Rajang Campus",
    IPG_KAMPUS_SARAWAK: "Institut Pendidikan Guru (IPG) (Kampus Sarawak)",
    IPG_KAMPUS_SULTAN_ABDUL_HALIM: "Institut Pendidikan Guru (IPG) (Kampus Sultan Abdul Halim)",
    IPG_KAMPUS_TEMENGGONG_IBRAHIM: "Institut Pendidikan Guru (IPG) (Kampus Temenggong Ibrahim)",
    IPG_TENGKU_AMPUAN_CAMPUS: "Institute of Teachers Education Tengku Ampuan Campus",
    IPG_KAMPUS_TUANKU_BAINUN: "Institut Pendidikan Guru (IPG) (Kampus Tuanku Bainun)",
    IPG_KAMPUS_TUN_HUSSEIN_ONN: "Institut Pendidikan Guru (IPG) (Kampus Tun Hussein Onn)",
    IPG_KAMPUS_TAWAU: "Institut Pendidikan Guru (Kampus Tawau)",
    IPG_INTL_LANGUAGES_CAMPUS: "Institute of Teacher Education International Languages Campus",
    IPG_KAMPUS_BATU_LINTANG: "Institut Pendidikan Guru Kampus Batu Lintang",
    IPG_GAYA_CAMPUS: "Institute of Teacher Education Gaya Campus",
    IPG_ILMU_KHAS_CAMPUS: "Institute of Teacher Education Ilmu Khas Campus",
    IPG_KAMPUS_KENINGAU: "Institut Pendidikan Guru Kampus Keningau",
    IPG_KAMPUS_KOTA_BHARU: "Institut Pendidikan Guru Kampus Kota Bharu",
    IPG_KAMPUS_PENDIDIKAN_ISLAM: "Institut Pendidikan Guru Kampus Pendidikan Islam",
    IPG_TECHNICAL_EDUCATION_CAMPUS: "Institute of Teacher Education Technical Education Campus",
    IPG_MALAY_WOMEN_CAMPUS: "Institute of Teacher Education Malay Women Campus",
    IPG_KAMPUS_RAJA_MELEWAR: "Institut Pendidikan Guru Kampus Raja Melewar",
    IPG_KAMPUS_SULTAN_MIZAN: "Institut Pendidikan Guru Kampus Sultan Mizan",
    IPG_KAMPUS_TUN_ABDUL_RAZAK: "Institut Pendidikan Guru Kampus Tun Abdul Razak",
    IPG_MALAYSIA: "Institute of Teacher Education Malaysia",
    IPDAS: "Institut Pengajian Islam dan Dakwah Sabah (IPDAS)",
    AGRI_INST_AYER_HITAM: "Agricultural Institute of Ayer Hitam",
    AGRI_INST_BUMBONG_LIMA: "Agricultural Institute of Bumbong Lima",
    AGRI_INST_SABAH: "Agricultural Institute of Sabah",
    AGRI_INST_SARAWAK: "Agricultural Institute of Sarawak",
    AGRI_INST_SERDANG: "Agricultural Institute of Serdang",
    INTAN: "National Institute of Public Administration (INTAN)",
    JMTI: "Japan Malaysia Technical Institute (JMTI)",
    KV_KAJANG: "Kolej Vokasional Kajang",
    KV_KOTA_TINGGI: "Kolej Vokasional Kota Tinggi",
    KV_SERI_MANJUNG: "Seri Manjung Vocational College",
    KV_SULTAN_AHMAD_SHAH: "Kolej Vokasional Sultan Ahmad Shah",
    KV_SULTAN_HAJI_AHMAD_SHAH_AL_MUSTAIN_BILLAH: "Kolej Vokasional Sultan Haji Ahmad Shah Al-Musta’in Billah",
    KV_TEMERLOH: "Kolej Vokasional Temerloh",
    KV_TENGKU_AMPUAN_AFZAN: "Kolej Vokasional Tengku Ampuan Afzan",
    KKTM_BALIK_PULAU: "Kolej Kemahiran Tinggi MARA Balik Pulau",
    KKTM_KEMAMAN: "Kolej Kemahiran Tinggi MARA Kemaman",
    KKTM_KUANTAN: "Kolej Kemahiran Tinggi MARA Kuantan",
    KKTM_LEDANG: "Kolej Kemahiran Tinggi MARA Ledang",
    KKTM_LENGGONG: "Kolej Kemahiran Tinggi MARA Lenggong",
    KKTM_MASJID_TANAH: "Kolej Kemahiran Tinggi MARA Masjid Tanah",
    KKTM_PASIR_MAS: "Kolej Kemahiran Tinggi MARA Pasir Mas",
    KKTM_PETALING_JAYA: "Kolej Kemahiran Tinggi MARA Petaling Jaya",
    KKTM_REMBAU: "Kolej Kemahiran Tinggi MARA Rembau",
    KOLEJ_KEMAHIRAN_TINGGI_MARA_SRI_GADING: "Kolej Kemahiran Tinggi MARA Sri Gading",
    AMPANG_COMMUNITY_COLLEGE: "Ampang Community College",
    KOLEJ_KOMUNITI_ARAU: "Kolej Komuniti Arau",
    KOLEJ_KOMUNITI_ARAU_CAWANGAN_KANGAR: "Kolej Komuniti Arau Cawangan Kangar",
    KOLEJ_KOMUNITI_BAGAN_DATUK: "Kolej Komuniti Bagan Datuk",
    KOLEJ_KOMUNITI_BAGAN_SERAI: "Kolej Komuniti Bagan Serai",
    BALING_COMMUNITY_COLLEGE: "Baling Community College",
    KOLEJ_KOMUNITI_BANDAR_BAHARU: "Kolej Komuniti Bandar Baharu",
    KOLEJ_KOMUNITI_BANDAR_DARULAMAN: "Kolej Komuniti Bandar Darulaman",
    KOLEJ_KOMUNITI_BANDAR_DARULAMAN_CAWANGAN_JERLUN: "Kolej Komuniti Bandar Darulaman Cawangan Jerlun",
    BANDAR_PENAWAR_COMMUNITY_COLLEGE: "Bandar Penawar Community College",
    KOLEJ_KOMUNITI_BANDAR_PENAWAR_CAWANGAN_GELANG_PATAH: "Kolej Komuniti Bandar Penawar Cawangan Gelang Patah (Previously known as : Kolej Komuniti Cawangan Gelang Patah)",
    KOLEJ_KOMUNITI_CAWANGAN_GELANG_PATAH: "(Previously known as : Kolej Komuniti Cawangan Gelang Patah)",
    BANDAR_TENGGARA_COMMUNITY_COLLEGE: "Bandar Tenggara Community College",
    BATU_GAJAH_COMMUNITY_COLLEGE: "Batu Gajah Community College",
    KOLEJ_KOMUNITI_BATU_PAHAT: "Kolej Komuniti Batu Pahat",
    BAYAN_BARU_COMMUNITY_COLLEGE: "Bayan Baru Community College",
    BEAUFORT_COMMUNITY_COLLEGE: "Beaufort Community College",
    BENTONG_COMMUNITY_COLLEGE: "Bentong Community College",
    KOLEJ_KOMUNITI_BERA: "Kolej Komuniti Bera",
    KOLEJ_KOMUNITI_BESUT: "Kolej Komuniti Besut",
    BETONG_COMMUNITY_COLLEGE: "Betong Community College",
    KOLEJ_KOMUNITI_BUKIT_BERUANG: "Kolej Komuniti Bukit Beruang",
    KOLEJ_KOMUNITI_BUKIT_MERTAJAM: "Kolej Komuniti Bukit Mertajam (Previously known as : Community College (Bukit Mertajam Branch))",
    KOLEJ_KOMUNITI_CAWANGAN_LENGGONG: "Kolej Komuniti Cawangan Lenggong",
    KOLEJ_KOMUNITI_CHENDEROH: "Kolej Komuniti Chenderoh",
    KOLEJ_KOMUNITI_GERIK: "Kolej Komuniti Gerik",
    KOLEJ_KOMUNITI_GOPENG: "Kolej Komuniti Gopeng (Previously known as : RTC Gopeng Community College)",
    HULU_LANGAT_COMMUNITY_COLLEGE: "Hulu Langat Community College",
    HULU_SELANGOR_COMMUNITY_COLLEGE: "Hulu Selangor Community College",
    KOLEJ_KOMUNITI_JASIN: "Kolej Komuniti Jasin",
    KOLEJ_KOMUNITI_JELEBU: "Kolej Komuniti Jelebu",
    JELI_COMMUNITY_COLLEGE: "Jeli Community College",
    KOLEJ_KOMUNITI_JEMPOL: "Kolej Komuniti Jempol",
    JERAI_COMMUNITY_COLLEGE: "Jerai Community College",
    KOLEJ_KOMUNITI_JERANTUT: "Kolej Komuniti Jerantut",
    KOLEJ_KOMUNITI_KELANA_JAYA: "Kolej Komuniti Kelana Jaya",
    KEMAMAN_COMMUNITY_COLLEGE: "Kemaman Community College",
    KOLEJ_KOMUNITI_KEPALA_BATAS: "Kolej Komuniti Kepala Batas",
    KLANG_COMMUNITY_COLLEGE: "Klang Community College",
    KOLEJ_KOMUNITI_KLUANG: "Kolej Komuniti Kluang",
    KOK_LANAS_COMMUNITY_COLLEGE: "Kok Lanas Community College",
    KOLEJ_KOMUNITI_KOTA_MARUDU: "Kolej Komuniti Kota Marudu",
    KOTA_MELAKA_COMMUNITY_COLLEGE: "Kota Melaka Community College",
    KOTA_TINGGI_COMMUNITY_COLLEGE: "Kota Tinggi Community College",
    KUALA_KANGSAR_COMMUNITY_COLLEGE: "Kuala Kangsar Community College",
    KUALA_LANGAT_COMMUNITY_COLLEGE: "Kuala Langat Community College",
    KOLEJ_KOMUNITI_KUALA_LANGAT_CAWANGAN_SEPANG: "Kolej Komuniti Kuala Langat Cawangan Sepang (Previously known as : Kolej Komuniti Cawangan Sepang)",
    KOLEJ_KOMUNITI_KUALA_PILAH: "Kolej Komuniti Kuala Pilah",
    KOLEJ_KOMUNITI_KUALA_TERENGGANU: "Kolej Komuniti Kuala Terengganu",
    KOLEJ_KOMUNITI_KUALA_TERENGGANU_CAWANGAN_HULU_TERENGGANU: "Kolej Komuniti Kuala Terengganu Cawangan Hulu Terengganu",
    KOLEJ_KOMUNITI_KUALA_TERENGGANU_CAWANGAN_KUALA_NERUS: "Kolej Komuniti Kuala Terengganu Cawangan Kuala Nerus",
    KOLEJ_KOMUNITI_KUANTAN: "Kolej Komuniti Kuantan",
    KUCHING_COMMUNITY_COLLEGE: "Kuching Community College",
    KULIM_COMMUNITY_COLLEGE: "Kulim Community College",
    LAHAD_DATU_COMMUNITY_COLLEGE: "Lahad Datu Community College",
    KOLEJ_KOMUNITI_LEDANG: "Kolej Komuniti Ledang",
    LIPIS_COMMUNITY_COLLEGE: "Lipis Community College",
    MANJUNG_COMMUNITY_COLLEGE: "Manjung Community College",
    MAS_GADING_COMMUNITY_COLLEGE: "Mas Gading Community College",
    KOLEJ_KOMUNITI_MASJID_TANAH: "Kolej Komuniti Masjid Tanah",
    KOLEJ_KOMUNITI_MIRI: "Kolej Komuniti Miri",
    MUAR_COMMUNITY_COLLEGE: "Muar Community College",
    NIBONG_TEBAL_COMMUNITY_COLLEGE: "Nibong Tebal Community College",
    KOLEJ_KOMUNITI_PADANG_TERAP: "Kolej Komuniti Padang Terap",
    PAGOH_COMMUNITY_COLLEGE: "Pagoh Community College",
    PASIR_GUDANG_COMMUNITY_COLLEGE: "Pasir Gudang Community College",
    PASIR_MAS_COMMUNITY_COLLEGE: "Pasir Mas Community College",
    KOLEJ_KOMUNITI_PASIR_SALAK: "Kolej Komuniti Pasir Salak",
    KOLEJ_KOMUNITI_PAYA_BESAR: "Kolej Komuniti Paya Besar",
    KOLEJ_KOMUNITI_PAYA_BESAR_CAWANGAN_MARAN: "Kolej Komuniti Paya Besar Cawangan Maran (Previously known as : Kolej Komuniti Cawangan Maran)",
    KOLEJ_KOMUNITI_PEKAN: "Kolej Komuniti Pekan",
    PENAMPANG_COMMUNITY_COLLEGE: "Penampang Community College",
    RAUB_COMMUNITY_COLLEGE: "Raub Community College",
    KOLEJ_KOMUNITI_REMBAU: "Kolej Komuniti Rembau",
    KOLEJ_KOMUNITI_ROMPIN: "Kolej Komuniti Rompin",
    KOLEJ_KOMUNITI_SABAK_BERNAM: "Kolej Komuniti Sabak Bernam",
    KOLEJ_KOMUNITI_SANDAKAN: "Kolej Komuniti Sandakan",
    KOLEJ_KOMUNITI_SANTUBONG: "Kolej Komuniti Santubong",
    SARIKEI_COMMUNITY_COLLEGE: "Sarikei Community College",
    SEBERANG_JAYA_COMMUNITY_COLLEGE: "Seberang Jaya Community College",
    KOLEJ_KOMUNITI_SEGAMAT: "Kolej Komuniti Segamat",
    KOLEJ_KOMUNITI_SEGAMAT_2: "Kolej Komuniti Segamat 2",
    SELANDAR_COMMUNITY_COLLEGE: "Selandar Community College",
    SELAYANG_COMMUNITY_COLLEGE: "Selayang Community College",
    SEMPORNA_COMMUNITY_COLLEGE: "Semporna Community College",
    SHAH_ALAM_COMMUNITY_COLLEGE: "Shah Alam Community College",
    KOLEJ_KOMUNITI_SIK: "Kolej Komuniti Sik",
    SUNGAI_PETANI_COMMUNITY_COLLEGE: "Sungai Petani Community College",
    SUNGAI_SIPUT_COMMUNITY_COLLEGE: "Sungai Siput Community College",
    TAIPING_COMMUNITY_COLLEGE: "Taiping College Community",
    TAMBUNAN_COMMUNITY_COLLEGE: "Tambunan Community College",
    TAMPIN_COMMUNITY_COLLEGE: "Tampin Community College",
    TANGGA_BATU_COMMUNITY_COLLEGE: "Tangga Batu Community College",
    KOLEJ_KOMUNITI_TANJONG_KARANG: "Kolej Komuniti Tanjong Karang",
    TANJUNG_PIAI_COMMUNITY_COLLEGE: "Tanjung Piai Community College",
    KOLEJ_KOMUNITI_TAPAH: "Kolej Komuniti Tapah",
    TASEK_GELUGOR_COMMUNITY_COLLEGE: "Tasek Gelugor Community College",
    KOLEJ_KOMUNITI_TAWAU: "Kolej Komuniti Tawau",
    TELUK_INTAN_COMMUNITY_COLLEGE: "Teluk Intan Community College",
    TEMERLOH_COMMUNITY_COLLEGE: "Temerloh Community College",
    MARA_PROFESSIONAL_COLLEGE_AYER_MOLEK: "MARA Professional College Ayer Molek, Melaka (Previously known as : Kolej Profesional MARA (Melaka)",
    KOLEJ_PROFESIONAL_MARA_BANDAR_MELAKA: "Kolej Profesional MARA Bandar Melaka",
    KOLEJ_PROFESIONAL_MARA_BANDAR_PENAWAR: "Kolej Profesional MARA Bandar Penawar",
    KOLEJ_PROFESIONAL_MARA_BERANANG: "Kolej Profesional MARA Beranang",
    KOLEJ_PROFESIONAL_MARA_INDERA_MAHKOTA: "Kolej Profesional MARA Indera Mahkota",
    KOLEJ_PROFESIONAL_MARA_SERI_ISKANDAR: "Kolej Profesional MARA Seri Iskandar Perak",
    KOLEJ_VOKASIONAL_ERT_AZIZAH: "Kolej Vokasional (ERT) Azizah",
    KOLEJ_VOKASIONAL_ERT_SETAPAK: "Kolej Vokasional (ERT) Setapak",
    KOLEJ_VOKASIONAL_PERTANIAN_CHENOR: "Kolej Vokasional (Pertanian) Chenor",
    KOLEJ_VOKASIONAL_PERTANIAN_TELUK_INTAN: "Kolej Vokasional (Pertanian) Teluk Intan",
    KOLEJ_VOKASIONAL_ALOR_SETAR: "Kolej Vokasional Alor Setar",
    KOLEJ_VOKASIONAL_AMPANGAN: "Kolej Vokasional Ampangan",
    KOLEJ_VOKASIONAL_ARAU: "Kolej Vokasional Arau",
    KOLEJ_VOKASIONAL_BACHOK: "Kolej Vokasional Bachok",
    KOLEJ_VOKASIONAL_BALIK_PULAU: "Kolej Vokasional Balik Pulau",
    KOLEJ_VOKASIONAL_BATU_LANCHANG: "Kolej Vokasional Batu Lanchang",
    KOLEJ_VOKASIONAL_BATU_PAHAT: "Kolej Vokasional Batu Pahat",
    KOLEJ_VOKASIONAL_BEAUFORT: "Kolej Vokasional Beaufort",
    KOLEJ_VOKASIONAL_BESUT: "Kolej Vokasional Besut",
    KOLEJ_VOKASIONAL_BETONG: "Kolej Vokasional Betong",
    KOLEJ_VOKASIONAL_BINTULU: "Kolej Vokasional Bintulu",
    KOLEJ_VOKASIONAL_BUTTERWORTH: "Kolej Vokasional Butterworth",
    KOLEJ_VOKASIONAL_DATO_LELA_MAHARAJA: "Kolej Vokasional Dato' Lela Maharaja",
    KOLEJ_VOKASIONAL_DATO_UNDANG_HJ_MUHAMAD_SHARIP: "Kolej Vokasional Dato’ Undang Hj Muhamad Sharip",
    KOLEJ_VOKASIONAL_DATUK_SERI_ABU_ZAHAR_ISNIN: "Kolej Vokasional Datuk Seri Abu Zahar Isnin",
    KOLEJ_VOKASIONAL_DATUK_SERI_MOHD_ZIN: "Kolej Vokasional Datuk Seri Mohd Zin",
    KOLEJ_VOKASIONAL_DUNGUN: "Kolej Vokasional Dungun",
    KOLEJ_VOKASIONAL_GERIK: "Kolej Vokasional Gerik",
    KOLEJ_VOKASIONAL_GOMBAK: "Kolej Vokasional Gombak",
    KOLEJ_VOKASIONAL_IPOH: "Kolej Vokasional Ipoh",
    KOLEJ_VOKASIONAL_JUASSEH: "Kolej Vokasional Juasseh",
    KOLEJ_VOKASIONAL_KANGAR: "Kolej Vokasional Kangar",
    KOLEJ_VOKASIONAL_KEMAMAN: "Kolej Vokasional Kemaman",
    KOLEJ_VOKASIONAL_KENINGAU: "Kolej Vokasional Keningau",
    KOLEJ_VOKASIONAL_KERIAN: "Kolej Vokasional Kerian",
    KOLEJ_VOKASIONAL_KLANG: "Kolej Vokasional Klang",
    KOLEJ_VOKASIONAL_KLUANG: "Kolej Vokasional Kluang",
    KOLEJ_VOKASIONAL_KUALA_KANGSAR: "Kolej Vokasional Kuala Kangsar",
    KOLEJ_VOKASIONAL_KUALA_KLAWANG: "Kolej Vokasional Kuala Klawang",
    KOLEJ_VOKASIONAL_KUALA_KRAI: "Kolej Vokasional Kuala Krai",
    KOLEJ_VOKASIONAL_KUALA_SELANGOR: "Kolej Vokasional Kuala Selangor",
    KOLEJ_VOKASIONAL_KUANTAN: "Kolej Vokasional Kuantan",
    KOLEJ_VOKASIONAL_KUCHING: "Kolej Vokasional Kuching",
    KOLEJ_VOKASIONAL_KUDAT: "Kolej Vokasional Kudat",
    KOLEJ_VOKASIONAL_KULIM: "Kolej Vokasional Kulim",
    KOLEJ_VOKASIONAL_LABUAN: "Kolej Vokasional Labuan",
    VOCATIONAL_COLLEGE_LAHAD_DATU: "Vocational College of Lahad Datu",
    KOLEJ_VOKASIONAL_LANGKAWI: "Kolej Vokasional Langkawi",
    KOLEJ_VOKASIONAL_LEBUH_CATOR: "Kolej Vokasional Lebuh Cator",
    KOLEJ_VOKASIONAL_LIKAS: "Kolej Vokasional Likas",
    KOLEJ_VOKASIONAL_MATANG: "Kolej Vokasional Matang",
    KOLEJ_VOKASIONAL_MELAKA_TENGAH: "Kolej Vokasional Melaka Tengah",
    KOLEJ_VOKASIONAL_MIRI: "Kolej Vokasional Miri",
    KOLEJ_VOKASIONAL_MUADZAM_SHAH: "Kolej Vokasional Muadzam Shah",
    KOLEJ_VOKASIONAL_MUAR: "Kolej Vokasional Muar",
    KOLEJ_VOKASIONAL_NIBONG_TEBAL: "Kolej Vokasional Nibong Tebal",
    KOLEJ_VOKASIONAL_PASIR_MAS: "Kolej Vokasional Pasir Mas",
    KOLEJ_VOKASIONAL_PASIR_PUTEH: "Kolej Vokasional Pasir Puteh",
    KOLEJ_VOKASIONAL_PENGKALAN_CHEPA: "Kolej Vokasional Pengkalan Chepa",
    KOLEJ_VOKASIONAL_PERDAGANGAN: "Kolej Vokasional Perdagangan",
    KOLEJ_VOKASIONAL_PORT_DICKSON: "Kolej Vokasional Port Dickson",
    KOLEJ_VOKASIONAL_PUTERI_TEMERLOH: "Kolej Vokasional Puteri Temerloh",
    KOLEJ_VOKASIONAL_SANDAKAN: "Kolej Vokasional Sandakan",
    KOLEJ_VOKASIONAL_SEBERANG_PERAI: "Kolej Vokasional Seberang Perai",
    KOLEJ_VOKASIONAL_SEGAMAT: "Kolej Vokasional Segamat",
    KOLEJ_VOKASIONAL_SEPANG: "Kolej Vokasional Sepang",
    KOLEJ_VOKASIONAL_SERI_ISKANDAR: "Kolej Vokasional Seri Iskandar",
    KOLEJ_VOKASIONAL_SETAPAK: "Kolej Vokasional Setapak",
    KOLEJ_VOKASIONAL_SHAH_ALAM: "Kolej Vokasional Shah Alam",
    KOLEJ_VOKASIONAL_SIBU: "Kolej Vokasional Sibu",
    KOLEJ_VOKASIONAL_SLIM_RIVER: "Kolej Vokasional Slim River",
    KOLEJ_VOKASIONAL_SULTAN_ABDUL_SAMAD: "Kolej Vokasional Sultan Abdul Samad",
    KOLEJ_VOKASIONAL_SUNGAI_BULOH: "Kolej Vokasional Sungai Buloh",
    KOLEJ_VOKASIONAL_SUNGAI_PETANI_1: "Kolej Vokasional Sungai Petani 1",
    KOLEJ_VOKASIONAL_SUNGAI_PETANI_2: "Kolej Vokasional Sungai Petani 2",
    KOLEJ_VOKASIONAL_TAIPING: "Kolej Vokasional Taiping",
    KOLEJ_VOKASIONAL_TANAH_MERAH: "Kolej Vokasional Tanah Merah",
    KOLEJ_VOKASIONAL_TANJUNG_PIAI: "Kolej Vokasional Tanjung Piai",
    KOLEJ_VOKASIONAL_TANJUNG_PUTERI: "Kolej Vokasional Tanjung Puteri",
    KOLEJ_VOKASIONAL_TAWAU: "Kolej Vokasional Tawau",
    KOLEJ_VOKASIONAL_WAKAF_TEMBESU: "Kolej Vokasional Wakaf Tembesu",
    LANGKAWI_TOURISM_ACADEMY: "Langkawi Tourism Academy@Kolej Komuniti Langkawi",
    COOPERATIVE_COLLEGE_OF_MALAYSIA: "Co-Operative College of Malaysia (Previously known as : Maktab Kerjasama Malaysia)",
    MARA_JAPAN_INDUSTRIAL_INSTITUTE: "MARA-Japan Industrial Institute (MJII) (Previously known as : Kolej Kemahiran Tinggi MARA Beranang)",
    ADTEC_BATU_PAHAT: "Advanced Technology Training Center (ADTEC) Batu Pahat",
    ADTEC_BINTULU: "Pusat Latihan Teknologi Tinggi (ADTEC) Bintulu",
    ADTEC_JERANTUT: "Pusat Latihan Teknologi Tinggi (ADTEC) Jerantut",
    ADTEC_KEMAMAN: "Advanced Technology Training Centre (ADTEC) Kemaman",
    ADTEC_KULIM: "Advanced Technology Training Centre (ADTEC) Kulim",
    ADTEC_MELAKA: "Pusat Latihan Teknologi Tinggi (ADTEC) Melaka",
    ADTEC_SHAH_ALAM: "Advanced Technology Training Center (ADTEC) Shah Alam",
    ADTEC_TAIPING: "Advanced Technology Training Centre (ADTEC) Taiping",
    AIMST_UNIVERSITY: "AIMST University (Previously known as : Asian Institute of Medicine, Science & Technology (AIMST))",
    ALBUKHARY_INTERNATIONAL_UNIVERSITY: "Albukhary International University",
    AL_MADINAH_INTERNATIONAL_UNIVERSITY: "Al-Madinah International University (MEDIU)",
    ASIA_E_UNIVERSITY: "Asia e University (AeU)",
    ASIA_METROPOLITAN_UNIVERSITY: "Asia Metropolitan University (Previously known as : Asia Metropolitan University, Johor Bahru Branch Campus)",
    ASIA_METROPOLITAN_UNIVERSITY_CYBERJAYA: "Asia Metropolitan University Cyberjaya Campus (Previously known as : Asia Metropolitan University)",
    ASIA_PACIFIC_UNIVERSITY: "Asia Pacific University of Technology and Innovation (Previously known as : Asia Pacific University of Technology and Innovation (Asia Pacific UTI))",
    ASIA_SCHOOL_OF_BUSINESS: "Asia School of Business (ASB)",
    BINARY_UNIVERSITY: "Binary University of Management & Entrepreneurship (BUME) (Previously known as : Binary University College of Management and Entrepreneurship (BUCME))",
    CITY_UNIVERSITY: "City University (Previously known as : City University College of Science & Technology (CUCST))",
    CITY_UNIVERSITY_JB: "City University Johor Bahru Campus",
    CURTIN_UNIVERSITY_MALAYSIA: "Curtin University, Malaysia (Previously known as : Curtin University, Sarawak Malaysia)",
    DRB_HICOM_UNIVERSITY: "DRB-HICOM University of Automotive Malaysia (Previously known as : International College of Automotive)",
    HERIOT_WATT_UNIVERSITY_MALAYSIA: "Heriot-Watt University Malaysia",
    IMU_UNIVERSITY: "IMU University (Previously known as : International Medical University (IMU))",
    INCEIF_UNIVERSITY: "INCEIF University (Previously known as : International Centre for Education in Islamic Finance (INCEIF))",
    INFRASTRUCTURE_UNIVERSITY_KL: "Infrastructure University Kuala Lumpur (Previously known as : Kuala Lumpur Infrastructure University College (KLIUC))",
    INTI_INTERNATIONAL_UNIVERSITY: "INTI International University (Previously known as : INTI University College)",
    LIMKOKWING_UNIVERSITY: "Limkokwing University of Creative Technology (Previously known as : Limkokwing University College of Creative Technology)",
    MAHSA_UNIVERSITY: "MAHSA University (Previously known as : MAHSA University College)",
    MALAYSIA_UNIVERSITY_SCIENCE_TECH: "Malaysia University of Science and Technology (MUST)",
    MALAYSIAN_COOPERATIVE_UNIVERSITY: "Malaysian Cooperative Entrepreneurship University",
    MALAYSIAN_SUPPLY_CHAIN_INSTITUTE: "Malaysian Institute for Supply Chain Innovation (MISI)",
    MANAGEMENT_SCIENCE_UNIVERSITY: "Management and Science University (MSU) (Previously known as : Kolej Universiti Teknologi dan Pengurusan Malaysia (KUTPM))",
    MANIPAL_GLOBALNXT_UNIVERSITY: "Manipal GlobalNxt University",
    MERITUS_UNIVERSITY: "Meritus University",
    MILA_UNIVERSITY: "MILA University (Previously known as : Manipal International University (MIU))",
    MONASH_UNIVERSITY_MALAYSIA: "Monash University Malaysia (Previously known as : Monash University Sunway Campus Malaysia)",
    MULTIMEDIA_UNIVERSITY_MELAKA: "Multimedia University (MMU), Melaka Campus",
    MULTIMEDIA_UNIVERSITY_CYBERJAYA: "Multimedia University, Cyberjaya Campus",
    NEWCASTLE_UNIVERSITY_MALAYSIA: "Newcastle University Medicine Malaysia",
    NILAI_UNIVERSITY: "Nilai University (Previously known as : Nilai University College)",
    OPEN_UNIVERSITY_MALAYSIA: "Open University Malaysia (OUM)",
    PERDANA_UNIVERSITY: "Perdana University",
    PUTRA_BUSINESS_SCHOOL: "Putra Business School (PBS)",
    QUEST_INTERNATIONAL_UNIVERSITY: "Quest International University (QIU) (Previously known as : Quest International University Perak )",
    RAFFLES_UNIVERSITY: "Raffles University (RU) (Previously known as : Raffles University Iskandar (RUI))",
    ROYAL_COLLEGE_SURGEONS_MALAYSIA: "Royal College of Surgeons in Ireland and University College Dublin Malaysia Campus (Previously known as : Penang Medical College) ",
    SEGI_UNIVERSITY: "SEGi University (Previously known as : SEGi University College)",
    SUNWAY_UNIVERSITY: "Sunway University (Previously known as : Sunway University College (Kolej Universiti Sunway))",
    SWINBURNE_SARAWAK: "Swinburne University of Technology Sarawak Campus",
    TAYLORS_UNIVERSITY: "Taylor's University (Previously known as : Taylor's University College (Subang Jaya))",
    TAR_UMT: "Tunku Abdul Rahman University of Management and Technology (TAR UMT) (Previously known as : Tunku Abdul Rahman University College, Kuala Lumpur (Main Campus) )",
    TAR_UMT_JOHOR: "Tunku Abdul Rahman University of Management and Technology Cawangan Johor (Previously known as : Tunku Abdul Rahman University College Johor Branch Campus)",
    TAR_UMT_PAHANG: "Tunku Abdul Rahman University of Management and Technology Cawangan Pahang (Previously known as : Kolej Universiti Tunku Abdul Rahman Cawangan Pahang)",
    TAR_UMT_PERAK: "Tunku Abdul Rahman University of Management and Technology Cawangan Perak (Previously known as : Tunku Abdul Rahman University College Perak Branch Campus)",
    TAR_UMT_PENANG: "Tunku Abdul Rahman University of Management and Technology Cawangan Pulau Pinang (Previously known as : Tunku Abdul Rahman University College Penang Branch Campus)",
    TAR_UMT_SABAH: "Tunku Abdul Rahman University of Management and Technology Cawangan Sabah (Previously known as : Kolej Universiti Tunku Abdul Rahman Cawangan Sabah)",
    UCSI_UNIVERSITY: "UCSI University (Previously known as : Sedaya International College)",
    UCSI_TERENGGANU: "UCSI University (Terengganu Campus)",
    UCSI_BANDAR_SPRINGHILL: "UCSI University Bandar Springhill Campus",
    UCSI_SARAWAK: "UCSI University, Sarawak Campus (Previously known as : Kolej Antarabangsa Sedaya Sarawak)",
    UCYP_UNIVERSITY: "UCYP University (Previously known as : University College of Yayasan Pahang)",
    UNITAR_UNIVERSITY: "UNITAR International University (Previously known as : University of Management and Technology (UMTECH))",
    HELP_UNIVERSITY: "Universiti HELP (Previously known as : HELP University College)",
    UNISHAMS: "Universiti Islam Antarabangsa Sultan Abdul Halim Mu'adzam Shah (UniSHAMS) (Previously known as : INSANIAH University College (KUIN))",
    UNIVERSITI_ISLAM_MALAYSIA: "Universiti Islam Malaysia",
    UNIVERSITI_ISLAM_SELANGOR: "Universiti Islam Selangor (UIS) (Previously known as : Kolej Universiti Islam Antarabangsa Selangor (KUIS))",
    UNIKL_MIIT: "Universiti Kuala Lumpur - Kampus Kota (UniKL - Kampus Kota) Malaysian Institute of Information Technology (MIIT)",
    UNIKL_MIAT: "Universiti Kuala Lumpur - Malaysian Institute of Aviation Technology (UniKL MIAT)",
    UNIKL_MIMET: "Universiti Kuala Lumpur - Malaysian Institute of Marine Engineering Technology (UniKL MIMET)",
    UNIKL_MSI: "Universiti Kuala Lumpur - Malaysian Spanish Institute (UniKL MSI)",
    UNIKL_MAIN_BUSINESS_SCHOOL: "Universiti Kuala Lumpur (UniKL)(Previously known as : Universiti Kuala Lumpur - Kampus Kota (UniKL - Kampus Kota) Universiti Kuala Lumpur Business School)",
    UNIKL_MAIN: "Universiti Kuala Lumpur (UniKL)(Previously known as : Universiti Kuala Lumpur - Kampus Kota (UniKL - Kampus Kota))",
    UNIKL_BMI: "Universiti Kuala Lumpur Kampus Cawangan British Malaysian Institute (UniKL - BMI) (Previously known as : Universiti Kuala Lumpur - British Malaysian Institute (UniKL - BMI))",
    UNIKL_MESTECH:
        "Universiti Kuala Lumpur Kampus Cawangan Institute of Medical Science Technology (UniKL - MESTECH) (Previously known as : Universiti Kuala Lumpur - Institute of Medical Science Technology (UniKL - MESTECH))",
    UNIKL_MFI: "Universiti Kuala Lumpur Kampus Cawangan Malaysia France Institute (UniKL-MFI)",
    UNIKL_MIDI:
        "Universiti Kuala Lumpur Kampus Cawangan Malaysia Italy Design Institute (UniKL MIDI) (Previously known as : Universiti Kuala Lumpur - Institute of Product Design and Manufacturing (UniKL IPROM))",
    UNIKL_MICET: "Universiti Kuala Lumpur Kampus Cawangan Malaysian Institute of Chemical and Bioengineering Technology (UniKL MICET)",
    UNIKL_MITEC: "Universiti Kuala Lumpur Kampus Cawangan Malaysian Institute of Industrial Technology (UniKL - MITEC)",
    UNIKL_RCMP: "Universiti Kuala Lumpur Kampus Cawangan Royal College of Medicine Perak (UniKL-RCMP) (Previously known as : Universiti Kuala Lumpur - Royal College of Medicine Perak (UniKL RCMP))",
    UM_WALES: "Universiti Malaya-Wales (UM-Wales)",
    UPTM: "Universiti Poly-Tech Malaysia (UPTM) (Previously known as : Kolej Universiti Poly-Tech MARA (KUPTM) Kuala Lumpur)",
    UNISEL_BESTARI_JAYA: "Universiti Selangor (UNISEL), Kampus Bestari Jaya (Previously known as : Universiti Selangor (UNISEL), Kampus Berjuntai Bestari)",
    UNISEL_SHAH_ALAM: "Universiti Selangor (UNISEL), Shah Alam Campus (Previously known as : Universiti Industri Selangor (UNISEL))",
    USAS: "Universiti Sultan Azlan Shah (USAS) (Previously known as : Sultan Azlan Shah Islamic University College)",
    UTP: "Universiti Teknologi PETRONAS (UTP)",
    UTS: "Universiti Teknologi Sarawak (UTS)",
    UNITEN_SULTAN_AHMAD_SHAH: "Universiti Tenaga Nasional (UNITEN, Kampus Sultan Haji Ahmad Shah)",
    UNITEN_PUTRAJAYA: "Universiti Tenaga Nasional Kampus Putrajaya (UNITEN, Kampus Putrajaya)",
    UNIRAZAK_TUN_ABDUL_RAZAK: "Universiti Tun Abdul Razak (UNIRAZAK)(Previously known as : Universiti Tun Abdul Razak (PINTAR Campus))",
    UNIRAZAK: "Universiti Tun Abdul Razak (UNIRAZAK)",
    UNIRAZAK_PINTAR: "Universiti Tun Abdul Razak (UNIRAZAK) PINTAR Campus (Previously known as : Universiti Tun Abdul Razak (UNITAR))",
    UTAR: "Universiti Tunku Abdul Rahman (UTAR)",
    UTAR_SUNGAI_LONG: "Universiti Tunku Abdul Rahman (UTAR) Kampus Cawangan Sungai Long",
    UTAR_KL: "Universiti Tunku Abdul Rahman (UTAR), Kuala Lumpur Campus",
    UTAR_PJ: "Universiti Tunku Abdul Rahman (UTAR), Petaling Jaya Campus",
    UNIMY: "University Malaysia of Computer Science and Engineering (UNIMY)",
    UoC: "University of Cyberjaya (UoC) (Previously known as : Cyberjaya University College of Medical Sciences)",
    GEOMATIKA: "University of Geomatika Malaysia (Previously known as : Geomatika University College)",
    NOTTINGHAM_MALAYSIA: "University of Nottingham Malaysia (UNM) (Previously known as : The University of Nottingham Malaysia Campus (UNMC))",
    READING_MALAYSIA: "University of Reading Malaysia",
    UoSM: "University of Southampton Malaysia (UoSM) (Previously known as : University of Southampton Malaysia Campus (USMC)) ",
    WALES: "University Of Wales",
    WAWASAN_OPEN: "Wawasan Open University",
    XIAMEN_MALAYSIA: "Xiamen University Malaysia",
    ALFA_UC: "Alfa University College (AUC) (Previously known as : ALFA College) ",
    AUCMS: "Allianze University College of Medical Sciences (AUCMS) (Previously known as : Allianze College of Medical Sciences (ACMS))",
    BERJAYA_UC: "BERJAYA University College (Previously known as : BERJAYA University College of Hospitality)",
    FIRST_CITY_UC: "First City University College (Previously known as : KBU International College)",
    GENOVASI_UC: "Genovasi University College",
    HAN_CHIANG_UC: "Han Chiang University College of Communication (Previously known as : Han Chiang College)",
    ICATS_UC: "i-CATS University College (i-CATS UC) (Previously known as : International College of Advanced Technology Sarawak) ",
    IUCAS: "International University College of Arts and Science (I-UCAS)",
    IUCTT: "International University College Of Technology Twintech",
    IUCTT_KELANTAN: "International University College Of Technology Twintech (IUCTT) Kelantan Campus",
    FAIRVIEW_UC: "Kolej Universiti Fairview",
    ISLAM_PERLIS_UC: "Kolej Universiti Islam Perlis",
    SAITO_UC: "Kolej Universiti Saito (Previously known as : Saito College)",
    KPJ_UC: "KPJ Healthcare University College (Previously known as : Kolej Universiti Antarabangsa Kejururawatan dan Sains Kesihatan KPJ (KPJIUC))",
    KLMUC: "Kuala Lumpur Metropolitan University College (KLMUC) (Previously known as : Kolej Universiti Antarabangsa Cosmopoint)",
    LINCOLN_UC: "Lincoln University College (Previously known as : Lincoln College)",
    LINTON_UC: "Linton University College (Previously known as : Kolej Linton)",
    MUCM: "Manipal University College Malaysia (MUCM) (Previously known as : Melaka - Manipal Medical College)",
    NMUC: "Netherlands Maritime University College (NMUC) (Previously known as : Netherlands Maritime Institute of Technology (NMIT))",
    NEW_ERA_UC: "New Era University College (Previously known as : New Era College)",
    NBUC: "North Borneo University College (NBUC) (Previously known as : International University College of Technology Twintech (Sabah))",
    SOUTHERN_UC: "Southern University College (Previously known as : Southern College)",
    SPECTRUM_UC: "Spectrum International University College",
    SULTAN_ISMAIL_PETRA_UC: "Sultan Ismail Petra International Islamic University College (Previously known as : Sultan Ismail Petra International Islamic College)",
    TARUC_KL_PA: "Tunku Abdul Rahman University College, Kuala Lumpur (Main Campus) (Previously known as: Tunku Abdul Rahman College Pahang Branch Campus)",
    TARUC_KL_SA: "Tunku Abdul Rahman University College, Kuala Lumpur (Main Campus) (Previously known as: Tunku Abdul Rahman College Sabah Branch Campus)",
    TWINTECH_SD: "Twintech International University College of Technology, Sri Damansara Campus (Previously known as : L & G Twintech Institute Of Technology)",
    ISLAM_PAHANG: "Universiti Islam Pahang Sultan Ahmad Shah (Previously known as : Kolej Universiti Islam Pahang Sultan Ahmad Shah)",
    BESTARI_UC: "University College Bestari (Previously known as : Kolej Teknologi Bestari)",
    AGROSCIENCE_UC: "University College of Agroscience Malaysia (Previously known as : Kolej RISDA Melaka)",
    AVIATION_UC: "University College of Aviation Malaysia (UniCAM) (Previously known as : Aviation Management College)",
    UCMI: "University College of MAIWP International (UCMI)",
    UCSF: "University College Sabah Foundation (UCSF)",
    TATI_UC: "University College TATI (UC TATI) (Previously known as : Institut Teknikal Tinggi Terengganu (TATI))",
    UNIMEL: "University of Melaka (UNIMEL) (Previously known as : University College of Islam Melaka)",
    UOW_KDU_PENANG: "UOW MALAYSIA KDU Penang University College (Previously known as : KDU Penang University College)",
    UOW_KDU: "UOW MALAYSIA KDU University College (Previously known as : KDU University College)",
    VERITAS_UC: "Veritas University College",
    WIDAD_UC: "Widad University College",
    ADAM: "Academy of Digital Animation and Media",
    ADMAL: "Admal Aviation College",
    ADROIT: "Adroit College",
    ATC: "Advance Tertiary College (ATC College) (Previously known as : Kolej Pendidikan Tinggi Kemayan (Kemayan ATC Kuala Lumpur))",
    ADVENTIST: "Adventist College of Nursing and Health Sciences (Previously known as : Kolej Kejururawatan Adventist)",
    ALAM: "Akademi Laut Malaysia (ALAM) (Previously known as : Akademi Laut Malaysia Melaka (ALAM))",
    ALAM_TG: "Akademi Laut Malaysia (ALAM) Cawangan Terengganu",
    ALPHA_TECH: "Alpha College of Technology (Previously known as : Institut Pengurusan Pujangga)",
    AMC_UC: "AMC University College (Previously known as : AMC College)",
    ASA_COLLEGE: "ASA College",
    ASEANA_HEALTH: "Aseana International College of Health Sciences",
    ACESM: "Asia College of Exercise and Sport Medicine (ACESM)",
    APIIT: "Asia Pacific Institute of Information Technology (APIIT)",
    APFTA: "Asia Pasific Flight Training Academy",
    ASTIN: "Astin College (Previously known as : Kolej Pengurusan Astin)",
    ATI: "ATI College (Previously known as : Institut Pelancongan Asia)",
    AXISMATICS: "Axismatics Professional Institute",
    BAITULMAL_PRO: "Baitulmal Professional College Kuala Lumpur (Previously known as : Institut Profesional Baitulmal)",
    BERJAYA_COLLEGE: "Berjaya College (Previously known as : Berjaya College Of Nursing And Health Sciences)",
    BINARY_CITY: "Binary College (City Campus) (Previously known as : Binary Business School (Kuala Lumpur))",
    BOSTONWEB: "Bostonweb College of Technology and Management",
    BAC: "Brickfields Asia College",
    CITY_ACADEMY: "City Academy",
    CITY_BM: "City College of Business Management",
    CITYPRO: "Citypro Institute",
    CLARA: "Clara International Aesthetic College",
    MCS: "College MCS",
    AI_QURAN: "College of Al-Quran Terengganu (Previously known as : Kolej Yayasan Terengganu)",
    MANJUNG: "College of Nursing and Health Sciences Seri Manjung",
    CONSIST: "CONSIST College",
    COSMOPOINT_COLLEGE: "Cosmopoint College Kota Kinabalu (Previously known as : Kolej Teknologi Antarabangsa Cosmopoint Cawangan Kota Kinabalu)",
    COSMOPOINT_SEREMBAN: "Cosmopoint College Seremban (Previously known as : Cosmopoint International College of Technology Seremban Branch)",
    CRESCENDO: "Crescendo International College",
    CYBERJAYA_KK: "Cyberjaya College Kota Kinabalu (Previously known as : Asia Metropolitan College Kota Kinabalu)",
    CYBERJAYA_KUCHING: "Cyberjaya College Kuching (Previously known as : Asia Metropolitan College Kuching)",
    CYBERJAYA_INTL: "Cyberjaya International College",
    CYBERNETICS_INTL: "Cybernetics International College",
    DASEIN: "Dasein Academy of Art",
    DESPARK: "Despark College",
    DISTED: "Disted College (Previously known as : Disted-Stamford College)",
    DOMA: "DOMA College (Previously known as : Kolej Informatics (Kuala Lumpur))",
    DSH: "DSH Institute of Technology (Previously known as : Institut Sains Kesihatan DSH)",
    EAST_WEST_INTL: "East West International College",
    EASTERN: "Eastern College",
    EQUATOR: "Equator College",
    ERICAN_COLLEGE: "Erican College (Previously known as: Pusat Latihan Rekahias Dalaman Pratique)",
    ETRAIN_COLLEGE: "Etrain College",
    EU_INSTITUTE: "EU Institute",
    EXCEL_INTERNATIONAL_COLLEGE: "Excel International College",
    EXECUTIVE_COLLEGE: "Executive College (Previously known as: Institut Eksekutif)",
    FAJAR_INTERNATIONAL_COLLEGE: "Fajar International College (Previously known as: Kolej Fajar)",
    FAME_INTERNATIONAL_COLLEGE: "FAME International College (Previously known as: FTMS International College)",
    FELCRA_COLLEGE: "FELCRA College",
    FLAMINGO_INTERNATIONAL_COLLEGE: "Flamingo International College",
    FOOD_INSTITUTE_OF_MALAYSIA: "Food Institute of Malaysia",
    FTMS_COLLEGE: "FTMS College (Previously known as: Institut Latihan FTMS-ICL (Lebuh Ampang))",
    GEMILANG_COLLEGE: "Gemilang College",
    GENTING_INTI_INTERNATIONAL_COLLEGE: "Genting INTI International College",
    GEOSPATIAL_SCIENCE_TECH_COLLEGE: "Geospatial Science and Technology College",
    GERMAN_MALAYSIAN_INSTITUTE: "German Malaysian Institute (GMI)",
    GOON_INTERNATIONAL_COLLEGE: "Goon International College (Previously known as: Goon Institute)",
    GREENCITY_INTERNATIONAL_COLLEGE: "Greencity International College (Previously known as: Orange International College)",
    HAFIZ_COLLEGE: "Hafiz College",
    HELP_ACADEMY: "HELP Academy",
    HOSPITAL_FATIMAH_SCHOOL_OF_NURSING: "Hospital Fatimah School of Nursing",
    IACT_COLLEGE: "IACT College (International Advertising, Communication & Technology) (Previously known as: IACT College)",
    IBS_COLLEGE: "IBS College",
    ICAN_COLLEGE: "ICAN College (Previously known as: Kolej Integrasi Kejururawatan dan Kesihatan Bersekutu)",
    ICOOP_COLLEGE: "iCOOP College",
    IHM_COLLEGE: "IHM College (Previously known as: In-House Multimedia College)",
    IMH_ACADEMY: "IMH Academy",
    IMPERIA_COLLEGE: "Imperia College (Previously known as: Imperia College of Hospitality)",
    IMPERIUM_INTERNATIONAL_COLLEGE: "Imperium International College (Previously known as: HELP College of Arts and Technology)",
    IMPIANA_INTERNATIONAL_COLLEGE: "Impiana International College",
    INNOVATIVE_ENGINEERING_DESIGN_COLLEGE: "Innovative Engineering Design College (IEDC)",
    INNOVATIVE_INTERNATIONAL_COLLEGE: "Innovative International College",
    INNOVATIVE_SCHOOL_OF_MANAGEMENT: "Innovative School of Management (ISM) (Previously known as: SEED Business College)",
    INPENS_INTERNATIONAL_COLLEGE: "INPENS International College (Previously known as: Kolej INPENS)",
    INSTITUT_AKAUNTAN_KTC: "Institut Akauntan KTC",
    INSTITUT_AKAUNTAN_KTC_KLUANG: "Institut Akauntan KTC (Cawangan Kluang)",
    INSTITUT_AKAUNTAN_KTC_MUAR: "Institut Akauntan KTC (Cawangan Muar)",
    INSTITUT_AKAUNTAN_KTC_JOHOR_BAHARU: "Institut Akauntan KTC Cawangan Johor Bahru",
    INSTITUT_DAKWAH_ISLAMIAH_PERKIM: "Institut Dakwah Islamiah PERKIM (IDIP)",
    INSTITUT_FIRST_ROBOTICS_INDUSTRIAL_SCIENCE: "Institut First Robotics Industrial Science (FRIS)",
    INSTITUT_FMM: "Institut FMM",
    INSTITUT_HASANI_KEDAH: "Institut Hasani Kedah",
    INSTITUT_INFORMASI_MULTIMEDIA: "Institut Informasi Multimedia",
    INSTITUT_INTEGRASI_UTAMA_AVICENNA: "Institut Integrasi Utama Avicenna",
    INSTITUT_I_SYSTEMS_KLANG: "Institut I-Systems Klang (Previously known as: Institut Systematic (Klang))",
    INSTITUT_I_SYSTEMS_KUALA_LUMPUR: "Institut I-Systems Kuala Lumpur",
    INSTITUT_I_SYSTEMS_KUCHING: "Institut I-Systems Kuching",
    INSTITUT_MEDIA_INTEGRATIF_MALAYSIA: "Institut Media Integratif Malaysia (MIIM)",
    INSTITUT_OPTOPRENEUR: "Institut Optopreneur",
    INSTITUT_PELABURAN_PNB: "Institut Pelaburan PNB",
    INSTITUT_PENGAJIAN_GLOBAL: "Institut Pengajian Global",
    INSTITUT_PENGAJIAN_TINGGI_ISLAM_PERLIS: "Institut Pengajian Tinggi Islam Perlis (IPTIP)",
    INSTITUT_PENGURUSAN_MALAYSIA: "Institut Pengurusan Malaysia",
    INSTITUT_PENGURUSAN_TEKNOLOGI_UTARA: "Institut Pengurusan Teknologi Utara",
    INSTITUT_SAINS_DAN_PENGURUSAN: "Institut Sains dan Pengurusan",
    INSTITUT_SAINS_DAN_TEKNOLOGI_DARUL_TAKZIM: "Institut Sains dan Teknologi Darul Takzim (INSTEDT)",
    INSTITUT_SINARAN: "Institut Sinaran",
    INSTITUT_TEKNOLOGI_ANS: "Institut Teknologi A.N.S.",
    INSTITUT_TEKNOLOGI_ANOTHER_ANS: "Institut Teknologi ANS",
    INSTITUT_TEKNOLOGI_DAN_PENGURUSAN_LEBUH_VICTORIA: "Institut Teknologi Dan Pengurusan Lebuh Victoria (ITPLV)",
    INSTITUT_TEKNOLOGI_IBNU_SINA: "Institut Teknologi Ibnu Sina",
    INSTITUT_TEKNOLOGI_TUN_ABDUL_RAZAK_ALOR_SETAR: "Institut Teknologi Tun Abdul Razak (ITTAR Alor Setar)",
    INSTITUT_TEKNOLOGI_TUN_ABDUL_RAZAK_JOHOR_BAHARU: "Institut Teknologi Tun Abdul Razak (ITTAR Johor Bahru)",
    INSTITUT_TEKNOLOGI_TUN_ABDUL_RAZAK_KOTA_BHARU: "Institut Teknologi Tun Abdul Razak (ITTAR Kota Bharu)",
    INSTITUT_TEKNOLOGI_TUN_ABDUL_RAZAK_KUALA_LUMPUR: "Institut Teknologi Tun Abdul Razak (ITTAR Kuala Lumpur)",
    INSTITUT_TEKNOLOGI_TUN_ABDUL_RAZAK_PETALING_JAYA: "Institut Teknologi Tun Abdul Razak (ITTAR Petaling Jaya)",
    INSTITUT_TEKNOLOGI_TUN_ABDUL_RAZAK_PULAU_PINANG: "Institut Teknologi Tun Abdul Razak (ITTAR Pulau Pinang)",
    INTEC_EDUCATION_COLLEGE: "INTEC Education College",
    INTERNATIONAL_COLLEGE_IMPERIA: "International College Imperia (Previously known as: Imperia College)",
    INTERNATIONAL_COLLEGE_ADVANCED_TECH_SARAWAK: "International College of Advanced Technology Sarawak (i-CATS) Miri Branch",
    INTERNATIONAL_COLLEGE_CREATIVE_ARTS_TECH: "International College of Creative Arts Technology (Previously known as: Epitome College)",
    INTERNATIONAL_COLLEGE_HEALTH_SCIENCES: "International College Of Health Sciences (ICHS)",
    INTERNATIONAL_COLLEGE_MANAGEMENT_SPORTS: "International College of Management and Sports, ICMS (Previously known as: Cyberlynx International College)",
    INTERNATIONAL_COLLEGE_MUSIC: "International College of Music (ICOM)",
    INTERNATIONAL_COLLEGE_TECH_PROFESSIONAL: "International College of Technology & Professional (Previously known as: Kolej Teknologi dan Profesional Indera Kayangan)",
    INTERNATIONAL_COLLEGE_YAYASAN_MELAKA: "International College of Yayasan Melaka (Previously known as: Kolej Yayasan Melaka)",
    INTERNATIONAL_INSTITUTE_MANAGEMENT_TECH: "International Institute of Management and Technology (IIMAT)",
    INTERNATIONAL_INSTITUTE_SCIENCE_MANTIN: "International Institute of Science Mantin (Previously known as: Institute of Medical Sciences Mantin (IMM))",
    INTERNATIONAL_MEDICAL_COLLEGE_MELAKA: "International Medical College Melaka (Previously known as: Melaka Pantai College of Nursing and Health Science)",
    INTERNATIONAL_MEDICAL_COLLEGE_SUBANG_JAYA: "International Medical College Subang Jaya, Malaysia (Previously known as: Kolej Kejururawatan dan Sains Kesihatan Pantai)",
    INTERNATIONAL_OPEN_COLLEGE: "International Open College",
    INTI_COLLEGE_NILAI: "INTI College Nilai (Previously known as: INTI College Sarawak)",
    INTI_COLLEGE_SABAH: "INTI College Sabah",
    INTI_INTERNATIONAL_COLLEGE_KUALA_LUMPUR: "INTI International College Kuala Lumpur (Previously known as: Metropolitan College)",
    INTI_INTERNATIONAL_COLLEGE_PENANG: "INTI International College Penang",
    INTI_INTERNATIONAL_COLLEGE_SUBANG: "INTI International College Subang (Previously known as: INTI College Subang Jaya)",
    ISBAUK_THINKING_SKILLS_COLLEGE: "ISBAUK Thinking Skills College",
    ISLAMIC_COLLEGE_AS_SOFA: "Islamic College As-Sofa",
    ISLAMIC_COLLEGE_SCIENCE_TECH: "Islamic College of Science & Technology (Previously known as: Institut Pengajian Ilmu-Ilmu Islam)",
    ISLAMIC_COLLEGE_SCIENCE_TECH_TERENGGANU: "Islamic College of Science and Technology Terengganu Branch",
    ISLAND_COLLEGE_TECHNOLOGY: "Island College of Technology",
    I_SYSTEMS_COLLEGE_MIRI: "I-Systems College Miri",
    ITA_COLLEGE: "ITA College",
    JATI_INSTITUTE: "Jati Institute (Previously known as: Kolej Legenda Jati)",
    JENEVA_COLLEGE: "Jeneva College (Previously known as: Victoria International College Bandar Tasik Puteri)",
    JESSELTON_UNIVERSITY_COLLEGE: "Jesselton University College (Previously known as: Jesselton College)",
    KEMAYAN_ADVANCE_TERTIARY_COLLEGE: "Kemayan Advance Tertiary College (Penang Branch)",
    KERIS_COLLEGE: "Keris College",
    KIARA_COLLEGE: "Kiara College",
    KINABALU_COMMERCIAL_COLLEGE: "Kinabalu Commercial College",
    KINGS_UNIVERSITY_COLLEGE: "Kings University College (Previously known as: Kolej Bandar)",
    KIRKBY_INTERNATIONAL_COLLEGE: "Kirkby International College",
    KLIA_PROFESSIONAL_MANAGEMENT_COLLEGE: "KLIA Professional & Management College",
    KOJADI_INSTITUTE: "Kojadi Institute",
    KOLEJ_AMAN_BATU_PAHAT: "Kolej Aman Batu Pahat",
    KOLEJ_ANTARABANGSA_ALMACREST: "Kolej Antarabangsa Almacrest",
    KOLEJ_ANTARABANGSA_DUNIA_MELAYU_DUNIA_ISLAM: "Kolej Antarabangsa Dunia Melayu Dunia Islam (KADMDI) (Previously known as: Institut Kota Melaka)",
    KOLEJ_ANTARABANGSA_PENGURUSAN_HOTEL_YTL: "Kolej Antarabangsa Pengurusan Hotel YTL",
    KOLEJ_BAYU: "Kolej Bayu",
    KOLEJ_CHERMAI_JAYA: "Kolej Chermai Jaya",
    KOLEJ_DAR_AL_HIKMAH: "Kolej Dar Al-Hikmah",
    KOLEJ_DIKA: "Kolej Dika (Dika College)",
    KOLEJ_GEOMATIKA_KENINGAU: "Kolej Geomatika Cawangan Keningau",
    KOLEJ_IBUKOTA_KINABALU: "Kolej Ibukota Kinabalu",
    KOLEJ_IJN: "Kolej IJN",
    KOLEJ_INFORMASI_TEKNOLOGI_COSMOSPECT: "Kolej Informasi Teknologi Cosmospect",
    KOLEJ_INFORMATICS_KUCHING: "Kolej Informatics (Kuching)",
    KOLEJ_INTEGRASI_PERKEMBANGAN_KEMAHIRAN: "Kolej Integrasi Perkembangan Kemahiran (IPK)",
    KOLEJ_ISLAM_ANTARABANGSA: "Kolej Islam Antarabangsa",
    KOLEJ_ISLAM_TEKNOLOGI_ANTARABANGSA: "Kolej Islam Teknologi Antarabangsa (KITAB)",
    KOLEJ_I_SYSTEMS_JOHOR_BAHARU: "Kolej I-Systems Johor Bahru",
    KOLEJ_I_SYSTEMS_KOTA_KINABALU: "Kolej I-Systems Kota Kinabalu",
    KOLEJ_I_SYSTEMS_KUCHING: "Kolej I-Systems Kuching",
    KOLEJ_ITJ: "Kolej ITJ (Previously known as: Institut Teknologi Jaya)",
    KOLEJ_KAMUNTING: "Kolej Kamunting",
    KOLEJ_KARISMA: "Kolej Karisma",
    KOLEJ_KEJURURAWATAN_LAM_WAH_EE: "Kolej Kejururawatan Lam Wah Ee",
    KOLEJ_KEJURURAWATAN_TUN_TAN_CHENG_LOCK: "Kolej Kejururawatan Tun Tan Cheng Lock",
    KOLEJ_KETENGAH: "Kolej KETENGAH",
    KOLEJ_LAILA_TAIB: "Kolej Laila Taib (Previously known as: Kolej Bersatu Sarawak)",
    KOLEJ_LEGENDA: "Kolej Legenda",
    KOLEJ_MAHSA_KAMPUS_SABAH: "Kolej MAHSA Kampus Sabah",
    KOLEJ_MAXWELL: "Kolej Maxwell (Previously known as: Kolej Teknologi Kejuruteraan Perak)",
    KOLEJ_MDIS_MALAYSIA: "Kolej MDIS Malaysia",
    KOLEJ_METHODIST_KUALA_LUMPUR: "Kolej Methodist Kuala Lumpur",
    KOLEJ_MULTIMEDIA_SELATAN: "Kolej Multimedia (Selatan)",
    KOLEJ_MUTIARA: "Kolej Mutiara (Previously known as: Institut Mutiara Mopar (Kajang))",
    KOLEJ_NEGERI_CHEDANG_CAMPUS: "Kolej Negeri Chedang Campus",
    KOLEJ_OMEGA: "Kolej Omega (Previously known as: Institut Omega)",
    KOLEJ_PACIFIC_KUANTAN: "Kolej Pacific Kuantan",
    KOLEJ_PENDIDIKAN_PERDANA_KOPEDA: "Kolej Pendidikan Perdana (KOPEDA)",
    KOLEJ_PENGAJIAN_ISLAM_JOHOR_MARSAH: "Kolej Pengajian Islam Johor (MARSAH)",
    KOLEJ_PENGAJIAN_SISWAZAH_SEGI: "Kolej Pengajian Siswazah SEGi (Previously known as: Kolej Pengajian Siswazah Antarabangsa)",
    KOLEJ_PERDANA: "Kolej Perdana",
    KOLEJ_PERKEMBANGAN_AWAL_KANAK_KANAK: "Kolej Perkembangan Awal Kanak-kanak (Previously known as: Institute of Early Years Development)",
    KOLEJ_POLY_TECH_MARA_ALOR_SETAR: "Kolej Poly-Tech MARA Alor Setar",
    KOLEJ_POLY_TECH_MARA_BANGI: "Kolej Poly-Tech MARA Bangi",
    KOLEJ_POLY_TECH_MARA_BATU_PAHAT: "Kolej Poly-Tech MARA Batu Pahat",
    KOLEJ_POLY_TECH_MARA_CAWANGAN_KUANTAN: "Kolej Poly-Tech MARA Cawangan Kuantan (Previously known as: Kolej Yayasan Pelajaran MARA (Kuantan))",
    KOLEJ_POLY_TECH_MARA_CAWANGAN_SEMPORNA_SABAH: "Kolej Poly-Tech MARA Cawangan Semporna Sabah",
    KOLEJ_POLY_TECH_MARA_IPOH: "Kolej Poly-Tech MARA Ipoh",
    KOLEJ_POLY_TECH_MARA_KOTA_BHARU: "Kolej Poly-Tech MARA Kota Bharu",
    KOLEJ_POLY_TECH_MARA_KOTA_BHARU_KELANTAN: "Kolej Poly-Tech MARA Kota Bharu, Kelantan",
    KOLEJ_RAUDHAH_BUKIT_MERAH: "Kolej Raudhah Bukit Merah (Previously known as: Kolej Perkembangan Awal Kanak-Kanak Bukit Merah)",
    KOLEJ_REACH: "Kolej REACH",
    KOLEJ_RISDA_CAWANGAN_SEMPORNA: "Kolej Risda Cawangan Semporna",
    KOLEJ_SAL_KUALA_LUMPUR: "Kolej SAL (Kuala Lumpur)",
    KOLEJ_SEDAMAI: "Kolej SEDAMAI",
    KOLEJ_SEGI_PULAU_PINANG: "Kolej SEGi Pulau Pinang (Previously known as: Institut Perdagangan Sistematik)",
    KOLEJ_SENTRAL: "Kolej Sentral",
    KOLEJ_SERI_STAMFORD_MELAKA: "Kolej Seri Stamford Melaka (Previously known as: Stamford College Malacca)",
    KOLEJ_SIDMA: "Kolej SIDMA",
    KOLEJ_SPACE: "Kolej SPACE",
    KOLEJ_SUNWAY_KUALA_LUMPUR: "Kolej Sunway (Kuala Lumpur)",
    KOLEJ_TEKNOLOGI_ANTARABANGSA_COSMOPOINT_KLANG: "Kolej Teknologi Antarabangsa Cosmopoint Cawangan Klang (Previously known as: Kolej Teknologi Cosmopoint (Klang))",
    KOLEJ_TEKNOLOGI_ANTARABANGSA_COSMOPOINT_MUAR: "Kolej Teknologi Antarabangsa Cosmopoint Cawangan Muar (Previously known as: Institut Teknologi Maklumat Cosmopoint (Muar))",
    KOLEJ_TEKNOLOGI_ANTARABANGSA_CYBERNETICS: "Kolej Teknologi Antarabangsa Cybernetics (Previously known as: Kolej Teknologi Cybernetics)",
    KOLEJ_TEKNOLOGI_DARULNAIM: "Kolej Teknologi Darulnaim (Previously known as: Institut Teknologi Darulnaim)",
    KOLEJ_TEKNOLOGI_DARULNAIM_KUALA_LUMPUR: "Kolej Teknologi Darulnaim Cawangan Kuala Lumpur",
    KOLEJ_TEKNOLOGI_MEA: "Kolej Teknologi MEA",
    KOLEJ_TEKNOLOGI_MULIA: "Kolej Teknologi Mulia",
    KOLEJ_TEKNOLOGI_TIMUR: "Kolej Teknologi Timur",
    KOLEJ_TEKNOLOGI_TIMUR_PJ: "Kolej Teknologi Timur PJ",
    KOLEJ_TESDEC: "Kolej TESDEC",
    KOLEJ_UNIKOP: "Kolej Unikop",
    KOLEJ_UNITI_KOTA_BHARU: "Kolej UNITI Kota Bharu (Previously known as: Kolej Jamiah Islamiah Putra (Kolej JAIPUTRA))",
    KOLEJ_VISION: "Kolej Vision",
    KOLEJ_WIT: "Kolej WIT",
    KOLEJ_YAYASAN_ISLAM_TERENGGANU: "Kolej Yayasan Islam Terengganu",
    KOLEJ_YAYASAN_PAHANG: "Kolej Yayasan Pahang (Previously known as: Kolej Yayasan Pahang (Indera Mahkota))",
    KOLEJ_YAYASAN_UEM: "Kolej Yayasan UEM",
    KOMPAS_INTERNATIONAL_COLLEGE: "Kompas International College (Previously known as: Kompas Institute)",
    KPJ_COLLEGE_JOHOR_BAHARU: "KPJ International College of Nursing and Health Sciences Johor Bahru Branch",
    KPJ_COLLEGE_JOHOR_BAHARU_OLD: "KPJ International College of Nursing and Health Sciences Johor Bahru Branch (Previously known as: Malaysian College of Hospitality and Management)",
    KPJ_COLLEGE_PENANG: "KPJ International College of Nursing and Health Sciences Pulau Pinang Branch",
    KRIM_COLLEGE: "KRIM College of Technology & Innovation",
    KYS_BUSINESS_SCHOOL: "KYS Business School",
    LAKE_VIEW_COLLEGE: "Lake View College (Previously known as: Bukit Merah Laketown Institute Of Allied Health Sciences)",
    LEGEND_HOSPITALITY_COLLEGE: "Legend International College of Hospitality & Tourism",
    LES_COPAQUE_ANIMATION_ACADEMY: "Les' Copaque Animation Academy",
    LIFE_COLLEGE: "LIFE College",
    LIMKOKWING_EXECUTIVE_COLLEGE: "Limkokwing Executive Leadership College",
    LIMKOKWING_SARAWAK: "Limkokwing Institute of Creative Technology Sarawak Branch",
    LSBF_COLLEGE: "LSBF College (Previously known as: Elite International College)",
    MAHKOTA_HEALTH_SCIENCES: "Mahkota Institute of Health Sciences and Nursing",
    MAHSA_AVENUE_COLLEGE: "MAHSA Avenue International College (Previously known as: Mahsa Prima International College)",
    MAHSA_COLLEGE: "MAHSA College",
    MALACCA_SCIENCE_COLLEGE: "Malacca College of Science and Management",
    MALAYSIAN_INSTITUTE_ART: "Malaysian Institute of Art",
    MALAYSIAN_INTEGRATED_BUSINESS: "Malaysian Integrated Business College (Previously known as: Malaysian Institute of Baking)",
    MALVERN_ACADEMY: "Malvern International Academy (Previously known as: Malvern International College)",
    MANTISSA_COLLEGE: "Mantissa College (Previously known as: Mantissa Institute)",
    MASA_COLLEGE: "MASA College",
    MASTERSKILL_IPOH: "Masterskill Global College, Ipoh (Previously known as: Masterskill College of Nursing and Health, Ipoh Campus)",
    MASTERSKILL_KOTA_BHARU: "Masterskill Global College, Kota Bharu (Previously known as: Masterskill College (Kota Bharu Metro Campus))",
    MAXCEL_INSTITUTE: "Maxcel Institute Of Management",
    MCKL_PENANG: "MCKL College (Penang, Pykett Campus)",
    MICOST: "Melaka International College of Science and Technology (MiCoST)",
    MENTARI_COLLEGE: "Mentari College",
    MERIDIAN_SAITO: "Meridian Saito College (Previously known as: Business and Management International College (BMIC))",
    MERITUS_COLLEGE: "Meritus College (Previously known as: Langkawi International College)",
    MVUC_COLLEGE: "Metaverse Universal College (MVUC) (Previously known as: Ri-Yaz College)",
    METHODIST_PILLEY: "Methodist Pilley Institute",
    METROPOINT_COLLEGE: "Metropoint College",
    MONT_ROYALE_COLLEGE: "Mont Royale College",
    MSU_COLLEGE_AMPANG: "MSU College Ampang (Previously known as: Pusat Teknologi dan Pengurusan Lanjutan (PTPL) Ampang)",
    MSU_COLLEGE_KB: "MSU College Kota Bharu (Previously known as: Pusat Teknologi Dan Pengurusan Lanjutan (PTPL) Kota Bharu)",
    MSU_COLLEGE_SABAH: "MSU College Sabah (Previously known as: Kolej Pusat Teknologi dan Pengurusan Lanjutan (PTPL) Sabah)",
    MSU_COLLEGE_SARAWAK: "MSU College Sarawak (Previously known as: Pusat Teknologi dan Pengurusan Lanjutan (PTPL) Sarawak)",
    MSU_COLLEGE_SEREMBAN: "MSU College Seremban (Previously known as: Pusat Teknologi dan Pengurusan Lanjutan (PTPL) Seremban)",
    MSU_COLLEGE_SG_PETANI: "MSU College Sg Petani (Previously known as: Kolej PTPL Cawangan Sungai Petani)",
    MSU_COLLEGE_SHAH_ALAM: "MSU College Shah Alam (Previously known as: Pusat Teknologi dan Pengurusan Lanjutan (PTPL) Shah Alam)",
    MSU_COLLEGE_TERENGGANU: "MSU College Terengganu (Previously known as: Pusat Teknologi dan Pengurusan Lanjutan (PTPL) Terengganu)",
    MSU_PENANG_COLLEGE: "MSU Penang College (Previously known as: Kolej PTPL Penang)",
    MULTIMEDIA_COLLEGE: "Multimedia College (Previously known as: Kolej Latihan Telekom)",
    MULTIMEDIA_COLLEGE_EASTERN: "Multimedia College (Eastern)",
    MULTIMEDIA_COLLEGE_NORTHERN: "Multimedia College (Northern) (Previously known as: Kolej Latihan Telekom (Utara))",
    MULTIMEDIA_COLLEGE_SABAH: "Multimedia College (Sabah)",
    MULTIMEDIA_COLLEGE_SARAWAK: "Multimedia College (Sarawak)",
    MURNI_INT_COLLEGE: "Murni International College (Previously known as: Kolej Kejururawatan Murni)",
    MUTIARA_INT_COLLEGE: "Mutiara International College Of Technology Innovation (Previously known as: Institut Elektronik (Perak))",
    NATIONAL_OPHTHALMIC_SCIENCES: "National Institute of Ophthalmic Sciences",
    NATIONAL_INTEGRATED_COLLEGE: "National Integrated College (Previously known as: National Integrated Health Sciences College)",
    NAZA_COLLEGE: "NAZA College of Technology and Business",
    NEGERI_COLLEGE: "Negeri College",
    NEWBRIDGE_COLLEGE: "Newbridge College (Previously known as: Sinar College)",
    NEWTON_COLLEGE: "Newton College (Previously known as: Syuen College)",
    NIGHTINGALE_INT_COLLEGE: "Nightingale International College",
    NIRWANA_COLLEGE: "Nirwana College (Previously known as: Nirwana Institute)",
    NORTHERN_KL_INT_COLLEGE: "Northern Kuala Lumpur International College",
    OASIS_COLLEGE: "Oasis College",
    OCEAN_AUDIO_TECH: "Ocean Institute of Audio Technology",
    OLYMPIA_IPOH: "Olympia College Ipoh",
    OLYMPIA_JB: "Olympia College Johor Bahru",
    OLYMPIA_KL: "Olympia College Kuala Lumpur",
    OLYMPIA_PJ: "Olympia College Petaling Jaya",
    OLYMPIA_PENANG: "Olympia College Pulau Pinang",
    OLYMPIA_KUANTAN: "Olympia College, Kuantan",
    ONEWORLD_HANXIN: "Oneworld Hanxin College (Kolej Oneworld Hanxin) (Previously known as : One World Hanxing College of Journalism and Communication)",
    OPTIMA_INT_COLLEGE: "Optima International College (Previously known as: Optima College)",
    ORIENTAL_NILAM_COLLEGE: "Oriental Nilam College of Nursing and Health Sciences (Previously known as: Oriental Nilam College of Nursing and Allied Health Sciences)",
    PAAC_BUSINESS_INSTITUTE: "PAAC Business Institute",
    PENANG_INT_DENTAL_COLLEGE: "Penang International Dental College",
    PENANG_SKILLS_DEV_CENTRE: "Penang Skills Development Centre (PSDC)",
    PENINSULA_COLLEGE_GEORGETOWN: "Peninsula College Georgetown (Previously known as: Kolej I-Systems Bukit Mertajam)",
    PENINSULA_COLLEGE_SHAH_ALAM: "Peninsula College Shah Alam (Previously known as: ALC College)",
    PERAK_COLLEGE_TECHNOLOGY: "Perak College of Technology (Previously known as: Institut Teknologi Perak)",
    PERTAMA_INST_TECH: "Pertama Institute of Technology",
    PIA_COLLEGE: "PIA College (Previously known as: Institut Seni PIA)",
    PJ_COLLEGE_ART_DESIGN: "PJ College of Art and Design",
    POINT_COLLEGE: "Point College",
    POLY_TECH_MARA_KESEDAR: "Poly-Tech MARA KESEDAR College",
    PORTMAN_COLLEGE: "PORTMAN College",
    PREMIER_COLLEGE: "Premier College (Previously known as: ELS Language Centres)",
    PRESIDENT_COLLEGE: "President College",
    PSDC_COLLEGE: "PSDC College (Previously known as: Pahang Skill Development Centre (PSDC Kuantan))",
    PTPL_SENTRAL_KL: "Pusat Teknologi Dan Pengurusan Lanjutan (PTPL) Sentral @ Kuala Lumpur",
    PUTRA_INTELEK_INT_COLLEGE: "Putra Intelek International College (Previously known as: Kolej Putra Intelek)",
    PUTRA_INT_COLLEGE: "Putra International College (Previously known as: Institut Putra (Melaka))",
    QUEENS_COLLEGE: "Queens College",
    RAFFLES_COLLEGE: "Raffles College of Higher Education (Previously known as: Raffles Design Institute)",
    RAMSAY_SIME_DARBY_COLLEGE: "Ramsay Sime Darby Healthcare College (Previously known as: Sime Darby Nursing and Health Sciences College)",
    RANACO_EDU_TRAINING: "Ranaco Education and Training Institute (RETI)",
    REGAL_CITY_COLLEGE: "Regal City College",
    REGENT_COLLEGE: "Regent College (Previously known as: Cyber Putra College)",
    REGENT_SCHOOL_ECONOMICS: "Regent School of Economics",
    RELIANCE_COLLEGE: "Reliance College",
    RENAISSANCE_COLLEGE: "Renaissance College",
    RENG_COLLEGE_TECH_DESIGN: "RENG College of Technology and Design",
    RESTU_INT_COLLEGE: "Restu International College (Previously known as: Restu College)",
    RIAM_INST_TECH: "Riam Institute of Technology",
    SABAH_INST_ART: "Sabah Institute of Art",
    SAL_COLLEGE: "SAL College",
    SARAWAK_MARITIME_ACADEMY: "Sarawak Maritime Academy",
    SATT_COLLEGE: "SATT College",
    SC_COLLEGE: "SC College (Previously known as: Institut Profesional)",
    SEAFIELD_INT_COLLEGE: "Seafield International College",
    SEGI_COLLEGE_KD: "SEGi College Kota Damansara (Previously known as: SEGi College of Technology Kuala Lumpur)",
    SEGI_COLLEGE_KL: "SEGi College Kuala Lumpur",
    SEGI_COLLEGE_SARAWAK: "SEGi College Sarawak (Previously known as: Kolej IBMS (Bukit Mata))",
    SEGI_COLLEGE_SERI_KEMBANGAN: "SEGi College Seri Kembangan (Previously known as: Kolej Antarabangsa MSC)",
    SEGI_COLLEGE_SUBANG_JAYA: "SEGi College Subang Jaya (Previously known as: Kolej SEGi)",
    SENTRAL_COLLEGE_PENANG: "Sentral College Penang (Previously known as: Sentral Technology College Penang)",
    SENTRAL_DIGITAL_COLLEGE_KL: "Sentral Digital College Kuala Lumpur (Previously known as: Megatech International College)",
    SIDMA_COLLEGE_SARAWAK: "SIDMA College Sarawak",
    SMART_COLLEGE: "SMART College",
    SRI_AYU_COLLEGE: "Sri Ayu College (Previously known as: Institut Sri Ayu)",
    SRI_COLLEGE: "SRI College",
    STAMFORD_COLLEGE_KL: "Stamford College Kuala Lumpur (Previously known as: Stamford Management Centre)",
    STAMFORD_COLLEGE_PJ: "Stamford College Petaling Jaya",
    STRADFORD_INT_COLLEGE: "Stradford International College (Previously known as: Silicon Institute of Technology)",
    SUNWAY_COLLEGE_IPOH: "Sunway College Ipoh",
    SUNWAY_COLLEGE_JB: "Sunway College Johor Bahru",
    SUNWAY_COLLEGE_KUCHING: "Sunway College Kuching",
    SURYA_COLLEGE: "Surya College",
    TAFE_COLLEGE_SEREMBAN: "TAFE College Seremban",
    TAJ_INT_COLLEGE: "TAJ International College (Previously known as: Taj College)",
    TAR_EC_COLLEGE: "TAR EC College",
    TAYLORS_COLLEGE: "Taylor's College (Previously known as: Taylor's College Sri Hartamas)",
    TAYLORS_COLLEGE_PJ: "Taylor's College (Petaling Jaya)",
    TAYLORS_COLLEGE_SUBANG_JAYA: "Taylor's College Subang Jaya",
    TAYLORS_COLLEGE_HOSPITALITY: "Taylor's College, School Of Hospitality And Tourism",
    TECH_TERRAIN_COLLEGE: "Tech Terrain College",
    TECH_COLLEGE_SARAWAK: "Technology College Sarawak (Previously known as: Twintech College Sarawak Branch)",
    TPM_COLLEGE: "Technology Park Malaysia College (TPM College)",
    TERRA_COLLEGE: "Terra College",
    THE_ONE_ACADEMY: "The One Academy of Communication Design",
    THE_ONE_ACADEMY_PENANG: "The One Academy Penang",
    THE_OTOMOTIF_COLLEGE: "The Otomotif College",
    TMC_COLLEGE: "TMC College",
    TRAVEX_INT_COLLEGE: "Travex International College",
    TUNG_SHIN_ACADEMY: "Tung Shin Academy of Nursing",
    UCSI_COLLEGE: "UCSI College",
    UNIFIELD_INT_COLLEGE: "UNIFIELD International College (Previously known as: UNIFIELD Technology College)",
    UNITAR_COLLEGE: "UNITAR College (Previously known as: Institut Pengurusan Global)",
    UNITAR_COLLEGE_IPOH: "UNITAR College Ipoh (Previously known as: Cosmopoint College Ipoh)",
    UNITAR_COLLEGE_JB: "UNITAR College Johor Bahru (Previously known as: Cosmopoint College Johor Bharu)",
    UNITAR_COLLEGE_KB: "UNITAR College Kota Bharu (Previously known as: Cosmopoint College Kota Bharu)",
    UNITAR_COLLEGE_KT: "UNITAR College Kuala Terengganu (Previously known as: Cosmopoint College Kuala Terengganu)",
    UNITAR_COLLEGE_KUANTAN: "UNITAR College Kuantan (Previously known as: Cosmopoint College Kuantan)",
    UNITAR_COLLEGE_KUCHING: "UNITAR College Kuching (Previously known as: Cosmopoint College Kuching)",
    UNITAR_COLLEGE_MELAKA: "UNITAR College Melaka (Previously known as: Cosmopoint College Melaka)",
    UNITAR_COLLEGE_PENANG: "UNITAR College Penang (Previously known as: Cosmopoint College Pulau Pinang)",
    UNITAR_COLLEGE_SUNGAI_PETANI: "UNITAR College Sungai Petani (Previously known as: Cosmopoint College Sungai Petani)",
    UNITI_COLLEGE: "UNITI College",
    UOW_MALAYSIA_KDU: "UOW Malaysia KDU College (Previously known as: KDU College (PJ))",
    VERITAS_COLLEGE_JB: "Veritas College Johor Bahru (Previously known as: Kolej Reliance Cawangan Johor Bahru)",
    VERITAS_COLLEGE_PENANG: "Veritas College Penang (Previously known as: Reliance College Pulau Pinang)",
    VETA_COLLEGE: "VETA College",
    VICTORIA_INT_COLLEGE: "Victoria International College",
    WESTMINSTER_INT_COLLEGE: "Westminster International College",
    WIDAD_COLLEGE: "Widad College (Previously known as: Shahputra College Campus Pekan)",
    WIM_COLLEGE: "WIM College (Previously known as: Institut Pengurusan Wanita)",
    WINDFIELD_INT_COLLEGE: "Windfield International College",
    YAMAHA_ACADEMY: "Yamaha Academy of Art and Music",
    YPJ_COLLEGE: "Yayasan Pelajaran Johor College",
    YS_COLLEGE_TECH: "Yayasan Sabah College of Technology (Previously known as: Sabah Foundation Technical College)",
    YES_INT_COLLEGE: "YES International College (Previously known as: YES Academy)",
    YPC_INT_COLLEGE: "YPC International College (Previously known as: Kolej Teknologi YPC iT-Web)",
};
